import axios from 'axios';

export namespace XV2 {
    export namespace API {
        export namespace Dev24So {
            export const url = '/_dev/24so';
            export type Input = {};
            export type Output = any;
        }
        export namespace DevAdyen {
            export const url = '/_dev/adyen';
            export type Input = {};
            export type Output = {};
        }
        export namespace DevDevice {
            export const url = '/_dev/device';
            export type Input = {};
            export type Output = any;
        }
        export namespace DevEmail {
            export const url = '/_dev/email';
            export type Input = {};
            export type Output = any;
        }
        export namespace DevTest {
            export const url = '/_dev/test';
            export type Input = {};
            export type Output = any;
        }
        export namespace DevVbOrder {
            export const url = '/_dev/vb-order';
            export type Input = {};
            export type Output = {};
        }
        export namespace CronAdyenUpdateBalances {
            export const url = '/cron/adyen/updateBalances';
            export type Input = {};
            export type Output = {};
        }
        export namespace CronLEGACYHandleMenuChange {
            export const url = '/cron/LEGACY/handleMenuChange';
            export type Input = {};
            export type Output = {};
        }
        export namespace CronLEGACYHandleOpeningTime {
            export const url = '/cron/LEGACY/handleOpeningTime';
            export type Input = {};
            export type Output = {};
        }
        export namespace CronModelIntegrationPostArchivedOrders {
            export const url = '/cron/model/Integration/postArchivedOrders';
            export type Output = {};
            export type Input = {};
            type IntegrationItem = Omit<Integration, 'data'> & { data?: IntegrationDataAzureQueue };
        }
        export namespace CronModelOrderArchiveOrders {
            export const url = '/cron/model/Order/archiveOrders';
            export type Input = void;
            export type Output = void;
        }
        export namespace CronModelOrderCloseInactiveOrders {
            export const url = '/cron/model/Order/closeInactiveOrders';
            export type Input = void;
            export type Output = void;
        }
        export namespace CronModelOrderTODOAutoPay {
            export const url = '/cron/model/Order/TODO_autoPay';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelOrderProductCancelUnpaidTip {
            export const url = '/cron/model/OrderProduct/cancelUnpaidTip';
            export type Input = {};
            export type Output = void;
        }
        export namespace CronModelOrderProductResetPaymentStatus {
            export const url = '/cron/model/OrderProduct/resetPaymentStatus';
            export type Input = void;
            export type Output = void;
        }
        export namespace CronModelOrderProductLockClearLocks {
            export const url = '/cron/model/OrderProductLock/clearLocks';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelOrderProductStatusChangeTimestampSyncFromStatusChanges {
            export const url = '/cron/model/OrderProductStatusChangeTimestamp/syncFromStatusChanges';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelOutletUpdateQueueLimiter {
            export const url = '/cron/model/Outlet/updateQueueLimiter';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelOutletMenuChangeHandleMenuChanges {
            export const url = '/cron/model/OutletMenuChange/handleMenuChanges';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelPaymentCalculateMissingAmounts {
            export const url = '/cron/model/Payment/calculateMissingAmounts';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelPaymentCalculateTxCost {
            export const url = '/cron/model/Payment/calculateTxCost';
            export type Output = {};
            export type Input = {};
            type PaymentQueryResultItem = Pick<Payment, 'id' | 'locationId' | 'amount' | 'methodType'> & {};
        }
        export namespace CronModelSettlementLegacyAutoSettle {
            export const url = '/cron/model/Settlement/legacy/autoSettle';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelSettlementPayOutAdyen {
            export const url = '/cron/model/Settlement/payOutAdyen';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelSettlementSendToExternalProviders {
            export const url = '/cron/model/Settlement/sendToExternalProviders';
            export type Input = void;
            export type Output = void;
        }
        export namespace CronModelSettlementUpdateS3Data {
            export const url = '/cron/model/Settlement/updateS3Data';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronModelTerminalClearPendingService {
            export const url = '/cron/model/Terminal/clearPendingService';
            export type Input = void;
            export type Output = void;
        }
        export namespace CronProviderTripletexCacheAccounts {
            export const url = '/cron/provider/tripletex/cacheAccounts';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronProviderVisbookCacheAvailableRooms {
            export const url = '/cron/provider/visbook/cacheAvailableRooms';
            export type Input = {};
            export type Output = {};
        }
        export namespace CronSettlementLegacyAutoSettle {
            export const url = '/cron/settlement/legacy/autoSettle';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronStatsSync {
            export const url = '/cron/stats/sync';
            export type Input = void;
            export type Output = void;
        }
        export namespace CronStatsSyncToServerless {
            export const url = '/cron/stats/syncToServerless';
            export type Output = {};
            export type Input = {};
        }
        export namespace ExperimentalAnalyticsGetPerformance {
            export const url = '/experimental/analytics/getPerformance';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
                interval: number;
                rootCategory?: string;
            };
            export type Output = {
                kpis: {
                    seconds: number;
                    count: number;
                    statuses: [OrderProductStatus, OrderProductStatus];
                }[];
                avgSeconds: {
                    placedToInPreparation: number;
                    placedToReady: number;
                    readyToDelivered: number;
                    placedToDelivered: number;
                };
                averageTime: {
                    placedToInPreparation: string;
                    placedToReady: string;
                    readyToDelivered: string;
                    placedToDelivered: string;
                };
                productChart: any;
            };
            type QueryInput = {
                statuses: [OrderProductStatus, OrderProductStatus];
                between: [any, any];
                groupByDateFormat?: string;
            };
        }
        export namespace ExperimentalAnalyticsGetPerformanceDetails {
            export const url = '/experimental/analytics/getPerformanceDetails';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
                secondsThreshold: number;
                limit: number;
                statuses: [OrderProductStatus, OrderProductStatus];
                rootCategory?: string;
            };
            export type Output = {
                products: OrderProductStatusChangeTimestamp[];
            };
        }
        export namespace InternalDeviceEventSend {
            export const url = '/internal/DeviceEvent/send';
            export type Input = {
                events: (Event & {
                    userId?: number;
                    deviceFingerprint?: string;
                    text?: string;
                    data?: any;
                })[];
            };
            type Event =
                | {
                      type: 'payment_sales_receipt_phone';
                      payment: Payment;
                  }
                | {
                      type: 'payment_sales_receipt_qr';
                      payment: Payment;
                  }
                | {
                      type: 'order_create';
                      order: Order;
                      orderProducts: OrderProduct[];
                  }
                | {
                      type: 'order_product_status_change';
                      status: OrderProductStatus;
                      orderProduct: OrderProduct;
                  }
                | {
                      type: 'payment_create';
                      payment: Payment;
                  }
                | {
                      type: 'payment_sales_receipt_print';
                      payment: Payment;
                  };
            export type Output = {};
        }
        export namespace InternalPaymentAddFeeDescription {
            export const url = '/internal/payment/addFeeDescription';
            export type Input = {
                paymentId: number;
                description: string;
            };
            export type Output = void;
        }
        export namespace InternalPaymentHandleClientExternalProvider {
            export const url = '/internal/payment/handleClientExternalProvider';
            export type Input = {
                paymentId: number;
            };
            export type Output = void;
        }
        export namespace InternalPaymentHandleTripletex {
            export const url = '/internal/payment/handleTripletex';
            export type Input = {
                paymentId: number;
            };
            export type Output = void;
        }
        export namespace InternalPrinterPrintOrderProducts {
            export const url = '/internal/printer/printOrderProducts';
            export type Input = {
                orderProductIds: number[];
                printerId: number;
                isPrintModifiersSeparately: boolean;
            };
            export type Output = {};
        }
        export namespace InternalSettlementGetPayoutAmount {
            export const url = '/internal/settlement/getPayoutAmount';
            export type Input = { settlementId: number };
            export type Output = {
                payoutAmount: number;
                paymentCount: number;
                transactionFees: number;
                isValid: boolean;
                results: any[];
            };
        }
        export namespace InternalSettlementSettle {
            export const url = '/internal/settlement/settle';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                settlement?: Settlement;
            };
        }
        export namespace V1ActionLogTrack {
            export const url = '/v1/actionLog/track';
            export type Input = {
                actions: Action[];
            };
            type Action = ActionUserLogin | ActionOperatorLogin | ActionOperatorLogout;
            type ActionUserLogin = Shared & {
                type: 'user_login';
                userId: number;
            };
            type ActionOperatorLogin = Shared & {
                type: 'operator_login';
            };
            type ActionOperatorLogout = Shared & {
                type: 'operator_logout';
            };
            type Shared = { date?: string };
            export type Output = {};
        }
        export namespace V1AdminBootstrapLocation {
            export const url = '/v1/admin/bootstrapLocation';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                user: Pick<User, 'id' | 'areaCode' | 'phone' | 'isSuperAdmin'>;
                location: CompactLocation & {
                    outlets: Pick<Outlet, 'id' | 'name'>[];
                    integrations: Integration[];
                    locationConfigs: LocationConfig[];
                    courses: Pick<Course, 'id' | 'name'>[];
                    company: Pick<Company, 'id' | 'name'>;
                };
                locations: CompactLocation[];
                companies: Company[];
            };
            export type CompactLocation = Pick<Location, 'id' | 'name' | 'companyId'>;
        }
        export namespace V1AdminClientCreateClient {
            export const url = '/v1/admin/client/createClient';
            export type Input = {
                locationId: number;
                client: Partial<Client>;
            };
            export type Output = {};
        }
        export namespace V1AdminClientCreateGroup {
            export const url = '/v1/admin/client/createGroup';
            export type Input = {
                locationId: number;
                data: Partial<ClientGroup>;
            };
            export type Output = ClientGroup;
        }
        export namespace V1AdminClientDownloadClientInvoice {
            export const url = '/v1/admin/client/downloadClientInvoice';
            export type Input = {
                clientInvoiceId: number;
                groupDataPerBalance?: boolean;
                groupDataPerDate?: boolean;
                includeAccounts?: boolean;
                includeClientDetails?: boolean;
            };
            export type Output = {
                url: string;
            };
            type Item = {
                productId: number;
                productName: string;
                count: number;
                amount: number;
                accountId: number;
                accountName: string;
                accountCode: string;
                accountVatPercent: string;
                balanceId: number;
                balanceName: string;
                date: string;
            };
        }
        export namespace V1AdminClientGetGroups {
            export const url = '/v1/admin/client/getGroups';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                clients: Client[];
                groups: ClientGroup[];
                invoices: ClientInvoice[];
                balances: Balance[];
                clientMeta: Record<
                    string,
                    {
                        toCreateInvoiceAmount: number;
                        toCreateInvoiceCount: number;
                        toInvoiceAmount: number;
                        toInvoiceCount: number;
                    }
                >;
            };
        }
        export namespace V1AdminClientSendInvoice {
            export const url = '/v1/admin/client/sendInvoice';
            export type Input = {
                invoiceId: number;
                grouping: ('date' | 'balance')[];
            };
            export type Output = {};
        }
        export namespace V1AdminClientUpdateClient {
            export const url = '/v1/admin/client/updateClient';
            export type Input = {
                id: number;
                data: Partial<Client>;
            };
            export type Output = {};
        }
        export namespace V1AdminInventoryGetAccountingReport {
            export const url = '/v1/admin/inventory/getAccountingReport';
            export type Input = {
                inventoryId: number;
                countingReportSummaryId?: number;
                productIds: number[];
            };
            export type Output = any;
        }
        export namespace V1AdminKioskCrud {
            export const url = '/v1/admin/kiosk/crud';
            export type Input = {
                action: 'create_or_update' | 'delete';
                locationId: number;
                values: Partial<KioskDevice>[];
            };
            export type Output = {};
        }
        export namespace V1AdminKioskGetData {
            export const url = '/v1/admin/kiosk/getData';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                kioskDevices: KioskDevice[];
                terminals: Terminal[];
                outlets: Outlet[];
            };
        }
        export namespace V1AdminLocationConfigCreateOrUpdate {
            export const url = '/v1/admin/location/config/createOrUpdate';
            export type Input = {
                action: 'CREATE_OR_UPDATE' | 'DELETE';
                locationId: number;
                values: Partial<LocationConfig>[];
            };
            export type Output = {};
        }
        export namespace V1AdminLocationConfigGet {
            export const url = '/v1/admin/location/config/get';
            export type Input = {
                locationId: number;
                include?: 'Course'[];
            };
            export type Output = {
                configs: LocationConfig[];
                courses: Course[];
            };
        }
        export namespace V1AdminMenuGetDetails {
            export const url = '/v1/admin/menu/getDetails';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                locationId: number;
                menus: Menu[];
                products: Product[];
                tags: ProductTag[];
                menuRules: MenuRule[];
            };
        }
        export namespace V1AdminMenuUpdateProducts {
            export const url = '/v1/admin/menu/updateProducts';
            export type Input = {
                menuId: number;
                values: {
                    productId: MenuProduct['productId'];
                    position?: MenuProduct['position'];
                }[];
            };
            export type Output = {};
        }
        export namespace V1AdminMenuUpdateRule {
            export const url = '/v1/admin/menu/updateRule';
            export type Input = {
                locationId: number;
                type: 'CREATE_OR_UPDATE' | 'DELETE';
                values: Partial<MenuRule> | Partial<MenuRule>[];
                menuId?: number;
            };
            export type Output = {};
        }
        export namespace V1AdminMenuUpdateRuleTime {
            export const url = '/v1/admin/menu/updateRuleTime';
            export type Input = {
                locationId: number;
                ruleId: number;
                action?: 'CREATE_OR_UPDATE' | 'DELETE';
                values: MenuRuleTime[];
            };
            export type Output = Input;
        }
        export namespace V1AdminOutletGetDetails {
            export const url = '/v1/admin/outlet/getDetails';
            export type Input = {
                id: number;
            };
            export type Output = Pick<Outlet, 'id' | 'name' | 'location' | 'zones'> & {
                zoneGroups: OutputZoneGroup[];
            };
            export type OutputZoneGroup = Pick<ZoneGroup, 'id' | 'name' | 'menuId'> & {
                zones: Pick<Zone, 'id' | 'name' | 'position'>[];
                zoneGroups: OutputZoneGroup[];
            };
        }
        export namespace V1AdminProductGet {
            export const url = '/v1/admin/product/get';
            export type Input = {
                locationId: number;
                filter?: {
                    name?: Product['name'];
                    rootCategory?: Product['rootCategory'][];
                    category?: Product['category'][];
                    subCategory?: Product['subCategory'][];
                    tagIds?: ProductTag['id'][];
                };
            };
            export type Output = {
                products: Product[];
                productIdsFiltered: number[];
                tags: ProductTag[];
                accounts: Account[];
                filters: Filter[];
            };
            export type Filter =
                | {
                      field: string;
                      type: 'string';
                      placeholder: string;
                  }
                | {
                      field: string;
                      type: 'select';
                      options: { label; value; ui?: string }[];
                      placeholder: string;
                      mode?: 'multiple' | 'tags';
                  }
                | Filter[];
        }
        export namespace V1AdminProductReportCreateConsumptionReport {
            export const url = '/v1/admin/product/report/createConsumptionReport';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
                groupByField: 'account' | 'category' | 'subCategory' | 'product';
                downloadAs?: 'pdf';
            };
            export type Output = {
                items: ({
                    productId: OrderProduct['productId'];
                    productName: OrderProduct['productName'];
                    productCategory: OrderProduct['productCategory'];
                    productSubCategory: OrderProduct['productSubCategory'];
                    accountCode: string;
                    accountDisplayName: string;
                } & Pick<
                    Product,
                    | 'inventoryContainerType'
                    | 'inventoryContainerUnitType'
                    | 'inventoryContainerUnitAmount'
                    | 'inventoryBaseUnitAmount'
                >)[];
                data: DataItem[];
                url: string;
            };
            type DataItem = {
                key: string;
                label: string;
                value: string;
                count: number;
                consumptionAmount: number;
                items: DataItemProduct[];
            };
            type DataItemProduct = {
                key: string;
                label: string;
                value: string;
                count: number;
                productId: number;
                consumptionAmount: number;
            };
        }
        export namespace V1AdminProductUpdate {
            export const url = '/v1/admin/product/update';
            export type Input = {
                locationId: number;
                productIds: number[];
                values?: Partial<Product>;
                tagIdsToAdd?: number[];
                tagIdsToRemove?: number[];
                actions?: InputAction[];
            };
            export type InputAction = {
                type: 'ADD' | 'REMOVE';
                field: keyof Product | 'tagIds';
                value;
            };
            export type Output = {};
        }
        export namespace V1AdminProductUpdateValues {
            export const url = '/v1/admin/product/updateValues';
            export type Input = {
                actions: (InputPrice | InputChangeValue)[];
            };
            export type InputPrice = {
                type: 'change_price';
                field: 'price' | 'priceTakeaway' | 'costPrice';
                productId: number | number[];
                value: number;
                entitiesToUpdate: 'product' | 'menu' | 'all';
                menusToUpdate?: 'all' | number[];
            };
            export type InputChangeValue = {
                type: 'change_value';
                productId: number | number[];
                values: InputChangeValueValue[];
            };
            export type InputChangeValueValue<T extends keyof Product = keyof Product> = {
                field: T;
                value: Product[T];
            };
            export type Output = {};
        }
        export namespace V1AdminProductTagCreateOrUpdate {
            export const url = '/v1/admin/productTag/createOrUpdate';
            export type Input = {
                action: 'CREATE_OR_UPDATE' | 'DELETE';
                locationId: number;
                values: Partial<ProductTag>[];
            };
            export type Output = {};
        }
        export namespace V1AdminSpillageCreateReport {
            export const url = '/v1/admin/spillage/createReport';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
            };
            export type Output = {
                reports: SpillageReport[];
            };
        }
        export namespace V1AnalyticsTest {
            export const url = '/v1/analytics/test';
            export type Input = {
                locationId: number;
                rootCategory?: string;
                from?;
                to?;
                interval?: number;
            };
            export type Output = {
                averageTime: {
                    placedToInPreparation: string;
                    placedToReady: string;
                    readyToDelivered: string;
                    placedToDelivered: string;
                };
                productChart: any;
            };
        }
        export namespace V1ApiV1FindValue {
            export const url = '/v1/api-v1/findValue';
            export type Input = {
                id: Value['id'];
            };
            export type Output = any;
        }
        export namespace V1AppCheckoutCancelPayment {
            export const url = '/v1/app/checkout/cancelPayment';
            export type Input = {
                paymentId: number;
            };
            export type Output = void;
        }
        export namespace V1AppCheckoutPreparePayment {
            export const url = '/v1/app/checkout/preparePayment';
            export type Input = {
                zoneId: number;
                orderProductIds: number[];
                tip?: number;
                meta?: {
                    isDesktop?: boolean;
                };
                version?: number;
            };
            export type Output = (PayAdyen | PayUnknown)[];
            export type Shared = {
                zoneId: number;
                paymentId: number;
                amount: number;
            };
            export type PayAdyen = Shared & {
                type: 'ADYEN';
                checkoutInput;
            };
            export type PayUnknown = Shared & {
                type: 'UNKNOWN';
            };
        }
        export namespace V1AppKioskClaimOrder {
            export const url = '/v1/app/kiosk/claimOrder';
            export type Input = {
                orderId: number;
            };
            export type Output = {
                paymentId: number;
            };
        }
        export namespace V1AppKioskTerminalPaymentCancel {
            export const url = '/v1/app/kiosk/terminalPayment/cancel';
            export type Input = {
                zoneId: number;
                paymentId: number;
            };
            export type Output = {};
        }
        export namespace V1AppKioskTerminalPaymentRequest {
            export const url = '/v1/app/kiosk/terminalPayment/request';
            export type Input = {
                zoneId: number;
                orderId: number;
            };
            export type Output = {
                paymentId: number;
                terminalId: number;
            };
        }
        export namespace V1AppPayGetLocks {
            export const url = '/v1/app/pay/getLocks';
            export type Input = {
                zoneId: number;
            };
            export type Output = OrderProductLock[];
        }
        export namespace V1AppPayUpdateLocks {
            export const url = '/v1/app/pay/updateLocks';
            export type Input = {
                zoneId: number;
                orderProductIds: number[];
            };
            export type Output = OrderProductLock[];
        }
        export namespace V1AppPlaceOrder {
            export const url = '/v1/app/placeOrder';
            export type Input = {
                zone: Pick<Zone, 'id'> | Pick<Zone, 'hash'>;
                products: {
                    ref: string;
                    productId: number;
                    modGroupIds?: Record<number, number[]>;
                    courseId?: number;
                    variantProductId?: number;
                }[];
                tip?: number;
                contact?: {
                    areaCode: string;
                    phone: string;
                };
            };
            export type Output = {
                orderId: number;
                sequence: number;
            };
        }
        export namespace V1AppTableBootstrap {
            export const url = '/v1/app/table/bootstrap';
            export type Input = {
                hash: string | number;
                zoneId?: number;
                lang?: I18nLang;
            };
            export type Output = {
                location: Pick<Location, 'id' | 'name' | 'imageBackground' | 'imageLogo'>;
                outlet: Pick<Outlet, 'id' | 'name' | 'image'>;
                zone?: Pick<Zone, 'id' | 'name'>;
                zones: Pick<Zone, 'id' | 'name'>[];
                products: (OutputProduct & {
                    variant?: Pick<Product['variantGroup'], 'id' | 'name' | 'description'> & {
                        products: OutputProduct[];
                    };
                    modifierGroups: ModifierGroup[];
                    promoted?: boolean;
                })[];
                courses: Pick<Course, 'id' | 'name'>[];
                styles: {
                    menuProductDivider?: string;
                };
                menuId?: number;
            };
            export type OutputProduct = Pick<
                Product,
                | 'id'
                | 'name'
                | 'description'
                | 'icon'
                | 'price'
                | 'priceTakeaway'
                | 'rootCategory'
                | 'category'
                | 'subCategory'
                | 'defaultCourseId'
                | 'allergens'
            >;
        }
        export namespace V1AppTableGetZoneState {
            export const url = '/v1/app/table/getZoneState';
            export type Input = {
                zoneId: number;
                orderId?: number;
            };
            export type Output = {
                zone: Pick<Zone, 'id' | 'hash' | 'name' | 'outletId'>;
                products: OrderProduct[];
                checkout: {
                    steps: CheckoutStep[];
                };
                amount: {
                    total: number;
                    paid: number;
                    remaining: number;
                };
                state: {
                    CALLING_WAITER?: { text: string };
                    SHOW_ALLERGENS?: boolean;
                    NUM_PEOPLE?: number;
                    TABLE_CSS?: string;
                };
            };
            export type CheckoutStep = CheckoutStepTip | CheckoutStepPay;
            export type CheckoutStepTip = {
                type: 'TIP';
                presets: {
                    percent: number;
                    label?: string;
                }[];
                forceSelection?: boolean;
                isDramatic?: boolean;
            };
            export type CheckoutStepPay = {
                type: 'PAY';
            };
        }
        export namespace V1AppTableUpdateValue {
            export const url = '/v1/app/table/updateValue';
            export type Input = {
                zoneId: number;
                values: InputValue[];
            };
            export type Output = {};
            export type InputValue =
                | {
                      action: 'ADD' | 'REMOVE';
                      type: 'CALLING_WAITER';
                      value?: string;
                  }
                | {
                      type: 'NUM_PEOPLE';
                      value: number;
                  }
                | {
                      type: 'SHOW_ALLERGENS';
                      value: boolean;
                  };
        }
        export namespace V1AuthLogin {
            export const url = '/v1/auth/login';
            export type Input = {
                areaCode: string;
                phone: string;
                password: string;
            };
            export type Output = {};
        }
        export namespace V1IngredientAction {
            export const url = '/v1/ingredient/action';
            export type Input = {
                locationId: number;
                ingredientIds: number[];
                productIds?: number[];
                stationIds?: number[];
                action: 'product_create' | 'product_delete' | 'station_create' | 'station_delete';
            };
            export type Output = {};
        }
        export namespace V1IngredientGet {
            export const url = '/v1/ingredient/get';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                ingredients: Ingredient[];
                products: Product[];
                stations: Station[];
            };
        }
        export namespace V1IngredientManage {
            export const url = '/v1/ingredient/manage';
            export type Input = {
                locationId: number;
                values: Partial<Ingredient>[];
                action: 'create' | 'delete';
            };
            export type Output = {};
        }
        export namespace V1IntegrationUpdateIntegration {
            export const url = '/v1/integration/updateIntegration';
            export type Input = {
                locationId: number;
                type: Integration['type'];
                values: Partial<Integration>;
                updateValuesOnly?: boolean;
            };
            export type Output = Integration;
        }
        export namespace V1OperatorExportGetForm {
            export const url = '/v1/operator/export/getForm';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                items: ExportItem[];
            };
            export type ExportItem = {
                type: 'PRODUCT_SALE';
                inputs: ExportItemInput[];
            };
            export type ExportItemInput = ExportItemInputDateRange | ExportItemInputSelectProduct;
            export type ExportItemInputDateRange = {
                type: 'DATE_RANGE';
                fields: [string, string];
            };
            export type ExportItemInputSelectProduct = {
                type: 'SELECT_PRODUCT';
                field: string;
                options: { label: string; value: number }[];
            };
        }
        export namespace V1OperatorExportSubmit {
            export const url = '/v1/operator/export/submit';
            export type Input = {
                locationId: number;
                type: 'PRODUCT_SALE';
                productIds: number[];
                from: string;
                to: string;
            };
            export type Output = {
                url: string;
            };
        }
        export namespace V1PosAnalyticsGetOverview {
            export const url = '/v1/pos/analytics/getOverview';
            export type Input = {
                locationId: number;
                groupBy?: 'outlet';
                period?: 'day' | 'week' | 'month';
                customRange?: { from: string; to: string };
            };
            export type Output = {
                params: {
                    from: string;
                    to: string;
                    groupBy?: Input['groupBy'];
                    period?: Input['period'];
                };
                items: {
                    key: string;
                    from: string;
                    to: string;
                    title: string;
                    subtitle: string;
                    amount: number;
                    percentOfTotal: number;
                }[];
            };
        }
        export namespace V1PosAnalyticsGetOverviewDetails {
            export const url = '/v1/pos/analytics/getOverviewDetails';
            export type Input = SharedType.Service.analytics.query.analyticsQueryPosOverview.Input;
            export type Output = SharedType.Service.analytics.query.analyticsQueryPosOverview.Output;
        }
        export namespace V1PosCourseBootstrap {
            export const url = '/v1/pos/course/bootstrap';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                zones: Pick<Zone, 'id' | 'name' | 'position'>[];
                courses: Pick<Course, 'id' | 'name' | 'position'>[];
                productMeta: Record<string, { name: string }>;
                styles;
            };
        }
        export namespace V1PosOutletBootstrap {
            export const url = '/v1/pos/outlet/bootstrap';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                outletId: number;
                outlet: Pick<Outlet, 'id' | 'name' | 'queueLimiterActive' | 'queueLimiterActiveLimit'> & {
                    zoneGroups: OutletZoneGroup[];
                };
                outletName: string;
                locationId: number;
                locationName: string;
                location: Pick<Location, 'id' | 'name'>;
                zones: Pick<Zone, 'id' | 'name'>[];
                features: FeatureType[];
                courses: Pick<Course, 'id' | 'name'>[];
                terminals: (Pick<Terminal, 'id' | 'pOIID' | 'isActive' | 'name' | 'terminalPaymentId'> & {
                    terminalPayment?: Pick<Payment, 'id' | 'status' | 'amount' | 'currency' | 'createdAt'>;
                })[];
                ui: Record<'posVersion' | 'outlet' | 'posCourseManagement', string | boolean | undefined>;
                filter: {
                    productTags: Pick<ProductTag, 'id' | 'name'>[];
                };
                config: {
                    queueLimiterOrigin: 's3' | 'api' | 'api-v2';
                    queueLimiterBaseUrl?: string;
                    queueLimiterIntervalSec: number;
                };
            };
            export type OutletZoneGroup = {
                id: number;
                name: string;
                zoneIds: number[];
                zoneGroups: OutletZoneGroup[];
            };
        }
        export namespace V1PosOutletCourseGetData {
            export const url = '/v1/pos/outlet/course/getData';
            export type Input = {
                outletId: number;
                filter?: {
                    orderProductRootCategory?: OrderProduct['productRootCategory'][];
                    orderProductStatus?: OrderProduct['status'][];
                    orderProductCourseId?: OrderProduct['courseId'][];
                    orderProductRequestStatus?: OrderProduct['requestStatus'][];
                    productTagId?: ProductTag['id'][];
                };
            };
            export type Output = {
                zones: Zone[];
                courses: Course[];
                orderProducts: OrderProduct[];
                orderMeta: Record<
                    string,
                    {
                        placedBy?: OrderPlacedBy;
                        operatorName?: string;
                    }
                >;
            };
            type ProductItem = {
                id: OrderProduct['id'];
                name: OrderProduct['productName'];
                createdAt: OrderProduct['createdAt'];
            };
        }
        export namespace V1PosOutletGetOrders {
            export const url = '/v1/pos/outlet/getOrders';
            export type Input = {
                outletId: number;
                zoneId?: number;
                stationId?: number;
                filter?: {
                    orderProductRootCategory?: OrderProduct['productRootCategory'][];
                    orderProductStatus?: OrderProduct['status'][];
                    orderProductCourseId?: OrderProduct['courseId'][];
                    orderProductRequestStatus?: OrderProduct['requestStatus'][];
                    productTagId?: ProductTag['id'][];
                    requestedBy?: 'chef' | 'waiter';
                };
                origin?: 'station_overview' | 'station';
            };
            export type Output = {
                zones: Zone[];
                courses: Course[];
                orderProducts: OutputOrderProduct[];
                orders: OrderItem[];
                orderMeta: Record<string, OrderItem>;
                stations: Pick<Station, 'id' | 'name'>[];
                stationRequests: OutputStationRequest[];
                allowedOrderProductStatuses: OrderProductStatus[];
            };
            type OrderItem = {
                id: Order['id'];
                createdAt: Order['createdAt'];
                placedAt: Order['placedAt'];
                sequence: Order['sequence'];
                placedBy: Order['placedBy'];
                placedFrom: Order['placedFrom'];
                zoneId: Order['zoneId'];
                zoneName: string;
                operatorName?: string;
            };
            type ProductItem = Pick<
                OrderProduct,
                | 'id'
                | 'productId'
                | 'productName'
                | 'createdAt'
                | 'status'
                | 'comment'
                | 'priceCombined'
                | 'productRootCategory'
                | 'productCategory'
                | 'productSubCategory'
                | 'requestStatus'
                | 'courseId'
                | 'orderId'
                | 'zoneId'
            > & {
                // orderProductModifiers: Pick<OrderProductModifier, 'id' | 'productName' | 'modifierName'>[];
                // orderProductModifiers: Pick<OrderProductModifier, 'productName' | 'modifierName' | 'modifierGroupName'>[];
                orderProductModifiers: OrderProductModifier[];
            };
            export type OutputOrderProduct = ProductItem & {
                ingredients: OutputIngredient[];
                origin: 'product' | 'ingredient';
                stationId?: number;
                requestedAt?: string;
                stationRequestId?: number;
                stationRequestAt?: string;
            };
            export type OutputIngredient = Pick<Ingredient, 'id' | 'name'> &
                Pick<OrderProductIngredient, 'status' | 'createdAt' | 'startedAt' | 'updatedAt' | 'finishedAt'>;
            export type OutputStationRequest = StationRequest & {
                orderProductIds: number[];
            };
        }
        export namespace V1PosOutletQueueLimiterGetData {
            export const url = '/v1/pos/outlet/queueLimiter/getData';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                count: number;
            };
        }
        export namespace V1PosOutletTableGetState {
            export const url = '/v1/pos/outlet/table/getState';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                zones: Pick<Zone, 'id' | 'name'>[];
                values: Pick<ZoneValue, 'zoneId' | 'type' | 'value' | 'createdAt'>[];
            };
        }
        export namespace V1PosOutletTerminalGetPayment {
            export const url = '/v1/pos/outlet/terminal/getPayment';
            export type Input = {
                terminalIds: number[];
            };
            export type Output = {
                payments: Payment[];
                paymentByTerminalId: Record<number, Payment>;
            };
        }
        export namespace V1PosPaymentGetPaymentMethods {
            export const url = '/v1/pos/payment/getPaymentMethods';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                methods: ({
                    name: string;
                    type: string;
                } & Record<string, any>)[];
            };
        }
        export namespace V1PosPosGetData {
            export const url = '/v1/pos/pos/getData';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                discounts: Pick<Discount, 'id' | 'name' | 'percent'>[];
                terminals: (Pick<Terminal, 'id' | 'pOIID' | 'isActive' | 'name' | 'terminalPaymentId'> & {
                    terminalPayment?: Pick<Payment, 'id' | 'status' | 'amount' | 'currency' | 'createdAt'>;
                })[];
                products: OutputProduct[];
                variantGroups: (Pick<VariantGroup, 'id' | 'name'> & {
                    products: OutputProduct[];
                })[];
                modifierGroups: (Pick<
                    ModifierGroup,
                    | 'id'
                    | 'name'
                    | 'description'
                    | 'autoSelectModifierId'
                    | 'autoSelectFirstModifier'
                    | 'createSeparateProducts'
                    | 'minAllowed'
                    | 'maxAllowed'
                    | 'presentationType'
                > & {
                    items: (Pick<ModifierGroupItem, 'id' | 'price'> & {
                        modifier: Pick<Modifier, 'id' | 'name'>;
                        product: OutputProduct;
                    })[];
                })[];
                config: {
                    categoryStyle: Record<string, any>;
                };
            };
            export type OutputProduct = Pick<
                Product,
                | 'id'
                | 'name'
                | 'icon'
                | 'rootCategory'
                | 'category'
                | 'subCategory'
                | 'variantGroupId'
                | 'price'
                | 'priceTakeaway'
                | 'defaultCourseId'
                | 'defaultRequestStatus'
            > & {
                menuId?: number;
                productModifierGroups: Pick<ProductModifierGroup, 'modifierGroupId'>[];
            };
        }
        export namespace V1PosPosGetHistory {
            export const url = '/v1/pos/pos/getHistory';
            export type Input = InputDeviceOrders | InputOutletOrders | InputOutletPayments;
            export type InputShared = {
                outletId: number;
                pagination: {
                    limit: number;
                    offset: number;
                };
            };
            export type InputDeviceOrders = InputShared & {
                type: 'device_orders';
            };
            export type InputOutletOrders = InputShared & {
                type: 'outlet_orders';
            };
            export type InputOutletPayments = InputShared & {
                type: 'outlet_payments';
                cardNumber?: string;
            };
            export type Output = {
                orders: {
                    orderId: number;
                    orderSequence: number;
                    orderDate: string;
                    zoneName: string;
                    orderProducts: OrderProduct[];
                    payment?: Payment;
                }[];
                payments: (Payment & {
                    orderProducts: OrderProduct[];
                })[];
            };
        }
        export namespace V1PosStationGetOrders {
            export const url = '/v1/pos/station/getOrders';
            export type Input = {
                outletIds?: number[];
                zoneIds?: number[];
                orderIds?: number[];
            };
            export type Output = {
                orders: OrderItem[];
                products: OrderProductItem[];
            };
            export type OrderItem = {
                orderId: number;
                orderSequence: number;
                orderPlacedAt;
                orderPlacedBy;
                orderTakeawayAt;
                outletId: number;
                outletName: string;
                zoneId: number;
                zoneName: string;
                productIds: number[];
            };
            export type OrderProductItem = Pick<
                OrderProduct,
                | 'id'
                | 'orderId'
                | 'productId'
                | 'productName'
                | 'status'
                | 'currency'
                | 'comment'
                | 'productRootCategory'
                | 'priceCombined'
                | 'paymentStatus'
                | 'zoneId'
                | 'outletId'
                | 'courseId'
                | 'requestStatus'
            >;
            export type OrderProductModifierItem = Pick<
                OrderProductModifier,
                | 'id'
                | 'modifierGroupName'
                | 'modifierName'
                | 'priceFinal'
                | 'productId'
                | 'productName'
                | 'productUnitAmount'
                | 'productBaseUnit'
                | 'productContainer'
            >;
        }
        export namespace V1PosStationIngredientUpdate {
            export const url = '/v1/pos/station/ingredient/update';
            export type Input = {
                outletId: number;
                values: Pick<OrderProductIngredient, 'orderProductId' | 'ingredientId'>[];
                status: OrderProductIngredient['status'];
            };
            export type Output = {};
        }
        export namespace V1PosStationRequest {
            export const url = '/v1/pos/station/request';
            export type Input = {
                outletId: number;
                orderProductIds: number[];
                minutes?: number;
            };
            export type Output = {};
        }
        export namespace V1PosUserGetLocations {
            export const url = '/v1/pos/user/getLocations';
            export type Input = {};
            export type Output = {
                locations: {
                    id: number;
                    name: string;
                    outlets: {
                        id: number;
                        name: string;
                    }[];
                }[];
            };
        }
        export namespace V1PosZoneDialogBootstrap {
            export const url = '/v1/pos/zone/dialog/bootstrap';
            export type Input = {
                zoneId: number;
            };
            export type Output = {
                zone: Pick<Zone, 'id' | 'name'>;
                outlet: Pick<Outlet, 'id' | 'name'>;
                orders: Order[];
                orderMeta: Record<number, OrderMeta>;
                orderProductMeta: Record<number, OrderProductMeta>;
            };
            export type OrderMeta = {
                operatorName?: string;
            };
            export type OrderProductMeta = {
                total: number;
                paid: number;
                missing: number;
                paymentStatus: 'paid' | 'missing' | 'partial' | 'cancelled';
            };
        }
        export namespace V1PosZoneGetDetails {
            export const url = '/v1/pos/zone/getDetails';
            export type Input = {
                zoneId: number;
            };
            export type Output = {
                zone: Zone;
                orders: Order[];
            };
        }
        export namespace V1PosZoneGetList {
            export const url = '/v1/pos/zone/getList';
            export type Input = {
                outletId: number;
                zoneGroupIds?: number[];
            };
            export type Output = {
                outletId: number;
                items: Item[];
                courses: Course[];
            };
            type Item = Pick<Zone, 'id' | 'name' | 'position'> & {
                active: boolean;
                clearable: boolean;
                amount: {
                    paid: number;
                    missing: number;
                    total: number;
                };
                courses: ItemCourse[];
            };
            export type ItemCourse = Pick<Course, 'id' | 'name'> & {
                status: CourseRequestStatus;
                timestamp?: string;
                allItemsReady?: boolean;
            };
            export type CourseRequestStatus =
                | 'EMPTY'
                | 'CAN_REQUEST'
                | 'REQUESTED'
                | 'READY'
                | 'IN_DELIVERY'
                | 'WAIT'
                | 'FINISHED';
            type ProductItem = { count: number } & Pick<
                OrderProduct,
                | 'zoneId'
                | 'status'
                | 'paymentStatus'
                | 'courseId'
                | 'requestStatus'
                | 'zoneName'
                | 'priceCombined'
                | 'updatedAt'
            >;
        }
        export namespace V1PosZoneLegacyGetZoneData {
            export const url = '/v1/pos/zone/legacy/getZoneData';
            export type Input = {
                zoneIds?: number[];
                outletId?: number;
            };
            export type Output = any;
            enum PosOutletGetZonesTerminalCourseStatus {
                EMPTY = 'EMPTY',
                CAN_REQUEST = 'CAN_REQUEST',
                REQUESTED = 'REQUESTED',
                READY = 'READY',
                WAIT = 'WAIT',
                FINISHED = 'FINISHED',
            }
        }
        export namespace V1ProductGet {
            export const url = '/v1/product/get';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                products: Product[];
                accounts: Account[];
            };
        }
        export namespace V1ProductI18NGet {
            export const url = '/v1/product/i18n/get';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                products: OutputProduct[];
                categories: OutputCategory[];
            };
            export type OutputProduct = {
                id: number;
                name: string;
                description: string;
                i18n: Record<
                    I18nLang,
                    {
                        name?: string;
                        description?: string;
                    }
                >;
            };
            export type OutputCategory = {
                key: string;
                value: string;
                i18n: Record<
                    I18nLang,
                    {
                        name?: string;
                        description?: string;
                    }
                >;
            };
        }
        export namespace V1ProductI18NUpdate {
            export const url = '/v1/product/i18n/update';
            export type Input = {
                locationId: number;
                values: {
                    productId: number;
                    lang: string;
                    key: 'name' | 'description';
                    value: string;
                }[];
            };
            export type Output = {};
        }
        export namespace V1Provider24SevenOfficeAssignCategoryToAccount {
            export const url = '/v1/provider/24-seven-office/assignCategoryToAccount';
            export type Input = {
                locationId: number;
                accountId: number;
                categoryId: number;
            };
            export type Output = {};
        }
        export namespace V1Provider24SevenOfficeGetAccountData {
            export const url = '/v1/provider/24-seven-office/getAccountData';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                accounts: {
                    key: string;
                    groupId: string;
                    displayName: string;
                    accountCode?: string;
                }[];
                officeAccounts: {
                    AccountId: number;
                    AccountNo: number;
                    AccountName: string;
                }[];
                taxCodes: {
                    AccountNo: number;
                    TaxId: number;
                    TaxName: string;
                    TaxNo: string;
                    TaxRate: number;
                }[];
            };
        }
        export namespace V1Provider24SevenOfficeGetAccountMappings {
            export const url = '/v1/provider/24-seven-office/getAccountMappings';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                items: {
                    accountId: number;
                    account: Account;
                    productId?: number;
                    productName?: string;
                    categoryId?: number;
                    categoryName?: string;
                }[];
                categories: {
                    Id: number;
                    Name: string;
                }[];
            };
        }
        export namespace V1Provider24SevenOfficeGetCustomers {
            export const url = '/v1/provider/24-seven-office/getCustomers';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                customers: {
                    Id: number;
                    Name: string;
                }[];
            };
        }
        export namespace V1Provider24SevenOfficeGetSettings {
            export const url = '/v1/provider/24-seven-office/getSettings';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                types: { key: string; value: number }[];
            };
        }
        export namespace V1Provider24SevenOfficeGetSettlementSyncData {
            export const url = '/v1/provider/24-seven-office/getSettlementSyncData';
            export type Input = {
                locationId: number;
                settlementId: number;
            };
            export type Output = any;
        }
        export namespace V1ProviderAdyenWebhookPayment {
            export const url = '/v1/provider/adyen/webhook/payment';
            export type Input = {};
            export type Output = {};
        }
        export namespace V1ProviderAdyenWebhookTransaction {
            export const url = '/v1/provider/adyen/webhook/transaction';
            export type Input = {};
            export type Output = {};
        }
        export namespace V1ProviderAwsGetIotUrl {
            export const url = '/v1/provider/aws/getIotUrl';
            export type Input = {};
            export type Output = {
                url: string;
            };
        }
        export namespace V1ProviderAzureQueueSendTestOrder {
            export const url = '/v1/provider/azure/queue/sendTestOrder';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                data: any;
                sendMessageResponse: any;
            };
        }
        export namespace V1ProviderAzureQueueTestConnection {
            export const url = '/v1/provider/azure/queue/testConnection';
            export type Input = {
                locationId: number;
                connectionString: string;
                queueName: string;
            };
            export type Output = {
                message: string;
                isSuccess: boolean;
            };
        }
        export namespace V1ProviderTripletexAutoMatchAccounts {
            export const url = '/v1/provider/tripletex/autoMatchAccounts';
            export type Input = {
                locationId: number;
            };
            export type Output = {};
        }
        export namespace V1ProviderTripletexGetAccountMappings {
            export const url = '/v1/provider/tripletex/getAccountMappings';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                items: {
                    type: 'ACCOUNT' | 'PAYMENT_METHOD' | 'OTHER';
                    key: string;
                    displayName: string;
                }[];
                tripletexAccounts: { displayName: string; number: number }[];
            };
        }
        export namespace V1ProviderTripletexGetCustomers {
            export const url = '/v1/provider/tripletex/getCustomers';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                customers: {
                    id: number;
                    name: string;
                    displayName: string;
                    organizationNumber: string;
                }[];
            };
        }
        export namespace V1ProviderTripletexTestConnection {
            export const url = '/v1/provider/tripletex/testConnection';
            export type Input = {
                locationId: number;
                values: {
                    consumerToken: string;
                    employeeToken: string;
                    baseUrl?: string;
                };
            };
            export type Output = {
                isSuccess: boolean;
            };
        }
        export namespace V1ProviderVisbookPutOnRoom {
            export const url = '/v1/provider/visbook/putOnRoom';
            export type Input = {
                locationId: number;
                roomId: number;
                paymentId: number;
            };
            export type Output = {};
        }
        export namespace V1ProviderVisbookRemoveFromRoom {
            export const url = '/v1/provider/visbook/removeFromRoom';
            export type Input = {
                locationId: number;
                visbookOrderId: number;
                orderProductIds: number[];
            };
            export type Output = {};
        }
        export namespace V1ProviderVisbookTestConnection {
            export const url = '/v1/provider/visbook/testConnection';
            export type Input = {
                locationId: number;
                values: {
                    username: string;
                    password: string;
                    companyId: number;
                };
            };
            export type Output = {
                isSuccess: boolean;
                errorMessage?: string;
            };
        }
        export namespace V1ProviderVisbookUpdateAndGetSetup {
            export const url = '/v1/provider/visbook/updateAndGetSetup';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                accounts: {
                    key: string;
                    displayName: string;
                    matchName?: string;
                    hasMatch: boolean;
                }[];
            };
        }
        export namespace V1ReportsSales {
            export const url = '/v1/reports/sales';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
                rowDateFormat: 'day' | 'week' | 'month';
                includeData: ('salesAccounts' | 'other')[];
            };
            export type Output = {
                url: string;
            };
            type PaymentQueryResultItem = Pick<Payment, 'id' | 'locationId' | 'amount' | 'methodType'> & {};
            type DataRow = {
                amount: number;
                date: any;
                dateOg: string;
                saleType: OrderProductSaleType;
                productAccountId: number;
                accountId: number;
                accountName: string;
                accountCode: string;
                accountVatPercent: number;
            };
        }
        export namespace V1SaAdyenCreateBalanceAccount {
            export const url = '/v1/sa/adyen/createBalanceAccount';
            export type Input = any;
            export type Output = {};
        }
        export namespace V1SaAdyenCreateLegalEntity {
            export const url = '/v1/sa/adyen/createLegalEntity';
            export type Input = {
                companyId: number;
                legalEntity: any;
                businessLine?: any;
                legalEntityId?: string;
            };
            export type Output = {
                legalEntity;
                accountHolder;
            };
        }
        export namespace V1SaAdyenCreateStore {
            export const url = '/v1/sa/adyen/createStore';
            export type Input = {
                locationId: number;
                areaCode: string;
                phone: string;
            };
            export type Output = {};
        }
        export namespace V1SaAdyenGetBalanceHistory {
            export const url = '/v1/sa/adyen/getBalanceHistory';
            export type Input = {
                accountHolderId?: number;
            };
            export type Output = Item[];
            export type Item = Pick<AdyenBalance, 'id' | 'createdAt' | 'amount' | 'amountPending' | 'amountHold'> & {
                company: Pick<Company, 'id' | 'name'>;
                accountHolder: Pick<AdyenAccountHolder, 'id' | 'code'>;
                adyenUrl: string;
                accounts: {
                    code: string;
                    amount: number;
                    amountPending: number;
                    amountHold: number;
                }[];
            };
        }
        export namespace V1SaAdyenGetCompanies {
            export const url = '/v1/sa/adyen/getCompanies';
            export type Input = {};
            export type Output = {
                companies: {
                    id: number;
                    name: string;
                    legalEntityId?: string;
                    accountHolderId?: string;
                    locations: Pick<Location, 'id' | 'name' | 'adyenBalanceAccountId'>[];
                }[];
            };
        }
        export namespace V1SaAdyenGetCompanyDetails {
            export const url = '/v1/sa/adyen/getCompanyDetails';
            export type Input = {
                companyId: number;
            };
            export type Output = {
                locations: (Pick<Location, 'id' | 'name' | 'adyenBalanceAccountId'> & {
                    storeId?: string;
                })[];
                businessLines: any[];
            };
        }
        export namespace V1SaAdyenTerminalsGet {
            export const url = '/v1/sa/adyen/terminals/get';
            export type Input = {};
            export type Output = {
                terminals: {
                    id: string;
                    terminalAdyen: TerminalAdyen;
                    terminal?: Terminal;
                }[];
            };
            export type TerminalAdyen = any;
        }
        export namespace V1SaAdyenUpdateAccountHolderBalances {
            export const url = '/v1/sa/adyen/updateAccountHolderBalances';
            export type Input = {};
            export type Output = {};
        }
        export namespace V1SaDashboardGetData {
            export const url = '/v1/sa/dashboard/getData';
            export type Input = {};
            export type Output = {
                payoutsMissing;
                payoutsFailed;
                failedSyncRequests: FailedSyncRequest[];
            };
            type FailedSyncRequest = {
                settlementId: number;
                provider: SettlementSyncRequestProvider;
                createdAt: string;
                sequence: number;
                locationId: number;
                locationName: string;
            };
        }
        export namespace V1SaModificationGet {
            export const url = '/v1/sa/modification/get';
            export type Input = {};
            export type Output = SystemModification[];
        }
        export namespace V1SaModificationUpdate {
            export const url = '/v1/sa/modification/update';
            export type Input = {
                values: SystemModification[];
            };
            export type Output = SystemModification[];
        }
        export namespace V1SaProfitGetReport {
            export const url = '/v1/sa/profit/getReport';
            export type Input = {
                locationIds: number[];
                from: string;
                to: string;
                downloadAs?: 'EXCEL';
            };
            export type Output = {
                items: any[];
            };
            type Item = {
                type: 'ecom' | 'pos';
                count: number;
                id: number;
                name: string;
                date;
                amountRefund: number;
                amountRemaining: number;
                amountPercent: number;
                costTransaction: number;
                costMarkupSchemeIc: number;
                costVipps: number;
                costTotal: number;
                profitServiceFee: number;
                profitTotal: number;
                amountPercentMinusTotalCost: number;
                profitPercentMinusServiceFee: number;
                profitPercent: number;
                averageTransaction: number;
            };
        }
        export namespace V1SaProfitGetTransactionPerformance {
            export const url = '/v1/sa/profit/getTransactionPerformance';
            export type Input = {
                from: string;
                to: string;
                locationIds?: number[];
            };
            export type Output = {
                best: Item[];
                worst: Item[];
            };
            type Item = {
                psp: string;
                date: Date;
                type: 'ecom' | 'pos';
                percent: number;
                amount: number;
                amountPercent: number;
                amountRefund: number;
                costFixed: number;
                costMarkupSchemeIc: number;
                costVipps: number;
                costTotal: number;
                profitServiceFee: number;
                profitTotal: number;
                locationId: number;
                locationName: string;
            };
        }
        export namespace V1SaUserGet {
            export const url = '/v1/sa/user/get';
            export type Input = {
                form?: {
                    email?: string;
                    phone?: string;
                };
            };
            export type Output = {
                users: User[];
            };
        }
        export namespace V1SettlementAnalyseSettlement {
            export const url = '/v1/settlement/analyseSettlement';
            export type Input = {
                locationId: number;
                settlementId: number;
            };
            export type Output = any;
        }
        export namespace V1SettlementCreateReport {
            export const url = '/v1/settlement/createReport';
            export type Input = SharedType.Model.Settlement.createReport.Input;
            export type Output = SharedType.Model.Settlement.createReport.Output;
            export type DataObject = SharedType.Model.Settlement.createReport.DataObject;
            export type RevenueType = SharedType.Model.Settlement.createReport.Shared['revenueType'];
        }
        export namespace V1SettlementGetHistory {
            export const url = '/v1/settlement/getHistory';
            export type Input = SharedType.DataQueryInput<{
                locationId: number;
            }>;
            export type Output = SharedType.DataQueryOutput<
                Pick<
                    Settlement,
                    'id' | 'sequence' | 'periodStart' | 'periodEnd' | 'description' | 'revenueTotalIncludingVat'
                > & {
                    adyenPayout?: any;
                    tripletexSettlement?: any;
                    sevenOfficeSettlement?: any;
                }
            >;
        }
        export namespace V1SettlementGetPendingSettlement {
            export const url = '/v1/settlement/getPendingSettlement';
            export type Input = {
                locationId: number;
                settlementId?: number;
            };
            export type Output = any;
        }
        export namespace V1SettlementGetSettlementSyncData {
            export const url = '/v1/settlement/getSettlementSyncData';
            export type Input = {
                locationId: number;
                settlementId: number;
                type: IntegrationType;
            };
            export type Output = any;
        }
        export namespace V1SettlementPayoutCreate {
            export const url = '/v1/settlement/payout/create';
            export type Input = {
                settlementId: number | number[];
            };
            export type Output = {};
        }
        export namespace V1SettlementProviderMarkAsManuallyHandled {
            export const url = '/v1/settlement/provider/markAsManuallyHandled';
            export type Input = {
                settlementId: number;
                provider: SettlementSyncRequestProvider;
            };
            export type Output = {};
        }
        export namespace V1SettlementReportCreate {
            export const url = '/v1/settlement/report/create';
            export type Input = SharedType.Model.Settlement.createReport.Input;
            export type Output = SharedType.Model.Settlement.createReport.Output;
        }
        export namespace V1SettlementReportDownload {
            export const url = '/v1/settlement/report/download';
            export type Input = SharedType.Model.Settlement.createReport.Input & {
                type: 'excel' | 'pdf';
            };
            export type Output = {
                url: string;
            };
        }
        export namespace V1SettlementSendSettlement {
            export const url = '/v1/settlement/sendSettlement';
            export type Input = {
                locationId: number;
                settlementId: number;
                type: IntegrationType;
            };
            export type Output = {};
        }
        export namespace V1SocketEmit {
            export const url = '/v1/socket/emit';
            export type Input = any;
            export type Output = any;
        }
        export namespace V1StationGet {
            export const url = '/v1/station/get';
            export type Input = {
                outletId: number;
                origin: 'overview' | 'station';
            };
            export type Output =
                | any
                | {
                      stations: Station[];
                      orderProducts: ProductItem[];
                  };
            export type ProductItem = Pick<OrderProduct, 'id' | 'productName'>;
        }
        export namespace V1StationManage {
            export const url = '/v1/station/manage';
            export type Input = {
                outletId: number;
                values: Partial<Station>[];
                action: 'create' | 'delete';
            };
            export type Output = {};
        }
        export namespace V1StationManageProducts {
            export const url = '/v1/station/manageProducts';
            export type Input = {
                locationId: number;
                stationIds: number[];
                productIds: number[];
                action: 'create' | 'delete';
            };
            export type Output = {};
        }
        export namespace V1UserAuthenticate {
            export const url = '/v1/user/authenticate';
            export type Input = {
                token: string;
            };
            export type Output = Pick<User, 'id'> & {
                token: string | undefined;
                deviceId?: string;
            };
        }
        export namespace V1UserMe {
            export const url = '/v1/user/me';
            export type Input = void;
            export type Output = User;
        }
        export namespace V1ZoneGroupCreateOrUpdate {
            export const url = '/v1/zoneGroup/createOrUpdate';
            export type Input = {
                outletId: number;
                values: Partial<SharedType.Nullable<ZoneGroup>>;
                zoneIds?: number[];
                zoneGroupIds?: number[];
            };
            export type Output = ZoneGroup;
        }
        export namespace V1ZoneGroupGetDetails {
            export const url = '/v1/zoneGroup/getDetails';
            export type Input = {
                locationId: number;
                zoneGroupId: number;
            };
            export type Output = {
                zoneGroup: ZoneGroup;
                zones: Zone[];
            };
        }
        export namespace V1ZoneGroupRemove {
            export const url = '/v1/zoneGroup/remove';
            export type Input = {
                id: number;
            };
            export type Output = void;
        }
        export namespace V1ZReportGetZReports {
            export const url = '/v1/zReport/getZReports';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                id: string;
                sequence: number;
                from: Date;
                to: Date;
            }[];
        }
        export namespace V1ZReportGetZReportSummary {
            export const url = '/v1/zReport/getZReportSummary';
            export type Input = {
                locationId: number;
                zReportId: number;
            };
            export type Output = {};
        }
        export namespace V2PosDeviceBootstrap {
            export const url = '/v2/pos/device/bootstrap';
            export type Input = {
                id: string;
            };
            export type Output = (NotFound | ConfirmationRequired | Registered | Locked) & {
                config?: Partial<any>;
            };
            export type NotFound = {
                type: 'not_found';
                message: string;
            };
            export type ConfirmationRequired = {
                type: 'confirmation_required';
                id: string;
                name: string;
            };
            export type Registered = {
                type: 'registered';
                id: string;
                name: string;
                settlementRequired?: {
                    cashTaken: number;
                };
            };
            export type Locked = {
                type: 'locked';
                html: string;
            };
        }
        export namespace V2PosDeviceConfirm {
            export const url = '/v2/pos/device/confirm';
            export type Input = {
                id: string;
            };
            export type Output =
                | {
                      type: 'not_found';
                      message: string;
                  }
                | {
                      type: 'registered';
                      id: string;
                      name: string;
                  };
        }
        export namespace V2PosDeviceEventSend {
            export const url = '/v2/pos/device/event/send';
            export type Input = {
                events: any[];
            };
            export type Output = {};
        }
        export namespace V2PosDeviceSettle {
            export const url = '/v2/pos/device/settle';
            export type Input = {
                deviceId: string;
                locationId: number;
            };
            export type Output = {};
        }
        export namespace V2PosPaymentDialogBootstrap {
            export const url = '/v2/pos/payment/dialog/bootstrap';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                paymentMethods: PaymentMethod[];
            };
            export type PaymentMethod =
                | PaymentMethodTerminal
                | PaymentMethodBalance
                | PaymentMethodGiftCard
                | PaymentMethodVisbook;
            export type PaymentMethodTerminal = {
                type: 'terminal';
                terminals: (Pick<Terminal, 'id' | 'pOIID' | 'isActive' | 'name' | 'terminalPaymentId'> & {
                    terminalPayment?: Pick<Payment, 'id' | 'status' | 'amount' | 'currency' | 'createdAt'>;
                })[];
            };
            export type PaymentMethodBalance = {
                type: 'balance';
                hasTipInput: true;
            };
            export type PaymentMethodGiftCard = {
                type: 'gift_card';
                hasTipInput: true;
            };
            export type PaymentMethodVisbook = {
                type: 'visbook';
            };
        }
        export namespace V2PosStationGetData {
            export const url = '/v2/pos/station/getData';
            export type Input = {
                outletIds: number[];
                filters: {
                    orderProductStatus?: OrderProductStatus[];
                    orderProductRootCategory?: ProductCategoryRoot[];
                    orderZoneId?: number[];
                    zoneGroupId?: number[];
                    tagId?: number[];
                };
            };
            export type Output = {
                orders: (Pick<Order, 'id' | 'sequence' | 'placedAt' | 'placedBy'> & {
                    zoneName: string;
                    operatorName?: string;
                    products: {
                        id: OrderProduct['id'];
                    }[];
                })[];
                productMeta: Record<string, Pick<Product, 'name'>>;
                orderProductMeta: Record<string, OutputOrderProduct>;
                orderProductModifiers: Record<string, OutputOrderProductModifier[]>;
            };
            export type OutputOrderProduct = Pick<
                OrderProduct,
                'status' | 'paymentStatus' | 'priceCombined' | 'productId' | 'comment'
            >;
            export type OutputOrderProductModifier = Pick<
                OrderProductModifier,
                'id' | 'name' | 'productId' | 'modifierId' | 'modifierName' | 'modifierGroupName'
            >;
        }
        export namespace V2PosStationGetOrder {
            export const url = '/v2/pos/station/getOrder';
            export type Input = {
                orderIds: number[];
            };
            export type Output = {};
        }
        export namespace Version {
            export const url = '/version';
            export type Output = {};
            export type Input = {};
        }
    }

    export type API_IO = {
        [API.Dev24So.url]: [API.Dev24So.Input, API.Dev24So.Output];
        [API.DevAdyen.url]: [API.DevAdyen.Input, API.DevAdyen.Output];
        [API.DevDevice.url]: [API.DevDevice.Input, API.DevDevice.Output];
        [API.DevEmail.url]: [API.DevEmail.Input, API.DevEmail.Output];
        [API.DevTest.url]: [API.DevTest.Input, API.DevTest.Output];
        [API.DevVbOrder.url]: [API.DevVbOrder.Input, API.DevVbOrder.Output];
        [API.CronAdyenUpdateBalances.url]: [API.CronAdyenUpdateBalances.Input, API.CronAdyenUpdateBalances.Output];
        [API.CronLEGACYHandleMenuChange.url]: [
            API.CronLEGACYHandleMenuChange.Input,
            API.CronLEGACYHandleMenuChange.Output,
        ];
        [API.CronLEGACYHandleOpeningTime.url]: [
            API.CronLEGACYHandleOpeningTime.Input,
            API.CronLEGACYHandleOpeningTime.Output,
        ];
        [API.CronModelIntegrationPostArchivedOrders.url]: [
            API.CronModelIntegrationPostArchivedOrders.Input,
            API.CronModelIntegrationPostArchivedOrders.Output,
        ];
        [API.CronModelOrderArchiveOrders.url]: [
            API.CronModelOrderArchiveOrders.Input,
            API.CronModelOrderArchiveOrders.Output,
        ];
        [API.CronModelOrderCloseInactiveOrders.url]: [
            API.CronModelOrderCloseInactiveOrders.Input,
            API.CronModelOrderCloseInactiveOrders.Output,
        ];
        [API.CronModelOrderTODOAutoPay.url]: [
            API.CronModelOrderTODOAutoPay.Input,
            API.CronModelOrderTODOAutoPay.Output,
        ];
        [API.CronModelOrderProductCancelUnpaidTip.url]: [
            API.CronModelOrderProductCancelUnpaidTip.Input,
            API.CronModelOrderProductCancelUnpaidTip.Output,
        ];
        [API.CronModelOrderProductResetPaymentStatus.url]: [
            API.CronModelOrderProductResetPaymentStatus.Input,
            API.CronModelOrderProductResetPaymentStatus.Output,
        ];
        [API.CronModelOrderProductLockClearLocks.url]: [
            API.CronModelOrderProductLockClearLocks.Input,
            API.CronModelOrderProductLockClearLocks.Output,
        ];
        [API.CronModelOrderProductStatusChangeTimestampSyncFromStatusChanges.url]: [
            API.CronModelOrderProductStatusChangeTimestampSyncFromStatusChanges.Input,
            API.CronModelOrderProductStatusChangeTimestampSyncFromStatusChanges.Output,
        ];
        [API.CronModelOutletUpdateQueueLimiter.url]: [
            API.CronModelOutletUpdateQueueLimiter.Input,
            API.CronModelOutletUpdateQueueLimiter.Output,
        ];
        [API.CronModelOutletMenuChangeHandleMenuChanges.url]: [
            API.CronModelOutletMenuChangeHandleMenuChanges.Input,
            API.CronModelOutletMenuChangeHandleMenuChanges.Output,
        ];
        [API.CronModelPaymentCalculateMissingAmounts.url]: [
            API.CronModelPaymentCalculateMissingAmounts.Input,
            API.CronModelPaymentCalculateMissingAmounts.Output,
        ];
        [API.CronModelPaymentCalculateTxCost.url]: [
            API.CronModelPaymentCalculateTxCost.Input,
            API.CronModelPaymentCalculateTxCost.Output,
        ];
        [API.CronModelSettlementLegacyAutoSettle.url]: [
            API.CronModelSettlementLegacyAutoSettle.Input,
            API.CronModelSettlementLegacyAutoSettle.Output,
        ];
        [API.CronModelSettlementPayOutAdyen.url]: [
            API.CronModelSettlementPayOutAdyen.Input,
            API.CronModelSettlementPayOutAdyen.Output,
        ];
        [API.CronModelSettlementSendToExternalProviders.url]: [
            API.CronModelSettlementSendToExternalProviders.Input,
            API.CronModelSettlementSendToExternalProviders.Output,
        ];
        [API.CronModelSettlementUpdateS3Data.url]: [
            API.CronModelSettlementUpdateS3Data.Input,
            API.CronModelSettlementUpdateS3Data.Output,
        ];
        [API.CronModelTerminalClearPendingService.url]: [
            API.CronModelTerminalClearPendingService.Input,
            API.CronModelTerminalClearPendingService.Output,
        ];
        [API.CronProviderTripletexCacheAccounts.url]: [
            API.CronProviderTripletexCacheAccounts.Input,
            API.CronProviderTripletexCacheAccounts.Output,
        ];
        [API.CronProviderVisbookCacheAvailableRooms.url]: [
            API.CronProviderVisbookCacheAvailableRooms.Input,
            API.CronProviderVisbookCacheAvailableRooms.Output,
        ];
        [API.CronSettlementLegacyAutoSettle.url]: [
            API.CronSettlementLegacyAutoSettle.Input,
            API.CronSettlementLegacyAutoSettle.Output,
        ];
        [API.CronStatsSync.url]: [API.CronStatsSync.Input, API.CronStatsSync.Output];
        [API.CronStatsSyncToServerless.url]: [
            API.CronStatsSyncToServerless.Input,
            API.CronStatsSyncToServerless.Output,
        ];
        [API.ExperimentalAnalyticsGetPerformance.url]: [
            API.ExperimentalAnalyticsGetPerformance.Input,
            API.ExperimentalAnalyticsGetPerformance.Output,
        ];
        [API.ExperimentalAnalyticsGetPerformanceDetails.url]: [
            API.ExperimentalAnalyticsGetPerformanceDetails.Input,
            API.ExperimentalAnalyticsGetPerformanceDetails.Output,
        ];
        [API.InternalDeviceEventSend.url]: [API.InternalDeviceEventSend.Input, API.InternalDeviceEventSend.Output];
        [API.InternalPaymentAddFeeDescription.url]: [
            API.InternalPaymentAddFeeDescription.Input,
            API.InternalPaymentAddFeeDescription.Output,
        ];
        [API.InternalPaymentHandleClientExternalProvider.url]: [
            API.InternalPaymentHandleClientExternalProvider.Input,
            API.InternalPaymentHandleClientExternalProvider.Output,
        ];
        [API.InternalPaymentHandleTripletex.url]: [
            API.InternalPaymentHandleTripletex.Input,
            API.InternalPaymentHandleTripletex.Output,
        ];
        [API.InternalPrinterPrintOrderProducts.url]: [
            API.InternalPrinterPrintOrderProducts.Input,
            API.InternalPrinterPrintOrderProducts.Output,
        ];
        [API.InternalSettlementGetPayoutAmount.url]: [
            API.InternalSettlementGetPayoutAmount.Input,
            API.InternalSettlementGetPayoutAmount.Output,
        ];
        [API.InternalSettlementSettle.url]: [API.InternalSettlementSettle.Input, API.InternalSettlementSettle.Output];
        [API.V1ActionLogTrack.url]: [API.V1ActionLogTrack.Input, API.V1ActionLogTrack.Output];
        [API.V1AdminBootstrapLocation.url]: [API.V1AdminBootstrapLocation.Input, API.V1AdminBootstrapLocation.Output];
        [API.V1AdminClientCreateClient.url]: [
            API.V1AdminClientCreateClient.Input,
            API.V1AdminClientCreateClient.Output,
        ];
        [API.V1AdminClientCreateGroup.url]: [API.V1AdminClientCreateGroup.Input, API.V1AdminClientCreateGroup.Output];
        [API.V1AdminClientDownloadClientInvoice.url]: [
            API.V1AdminClientDownloadClientInvoice.Input,
            API.V1AdminClientDownloadClientInvoice.Output,
        ];
        [API.V1AdminClientGetGroups.url]: [API.V1AdminClientGetGroups.Input, API.V1AdminClientGetGroups.Output];
        [API.V1AdminClientSendInvoice.url]: [API.V1AdminClientSendInvoice.Input, API.V1AdminClientSendInvoice.Output];
        [API.V1AdminClientUpdateClient.url]: [
            API.V1AdminClientUpdateClient.Input,
            API.V1AdminClientUpdateClient.Output,
        ];
        [API.V1AdminInventoryGetAccountingReport.url]: [
            API.V1AdminInventoryGetAccountingReport.Input,
            API.V1AdminInventoryGetAccountingReport.Output,
        ];
        [API.V1AdminKioskCrud.url]: [API.V1AdminKioskCrud.Input, API.V1AdminKioskCrud.Output];
        [API.V1AdminKioskGetData.url]: [API.V1AdminKioskGetData.Input, API.V1AdminKioskGetData.Output];
        [API.V1AdminLocationConfigCreateOrUpdate.url]: [
            API.V1AdminLocationConfigCreateOrUpdate.Input,
            API.V1AdminLocationConfigCreateOrUpdate.Output,
        ];
        [API.V1AdminLocationConfigGet.url]: [API.V1AdminLocationConfigGet.Input, API.V1AdminLocationConfigGet.Output];
        [API.V1AdminMenuGetDetails.url]: [API.V1AdminMenuGetDetails.Input, API.V1AdminMenuGetDetails.Output];
        [API.V1AdminMenuUpdateProducts.url]: [
            API.V1AdminMenuUpdateProducts.Input,
            API.V1AdminMenuUpdateProducts.Output,
        ];
        [API.V1AdminMenuUpdateRule.url]: [API.V1AdminMenuUpdateRule.Input, API.V1AdminMenuUpdateRule.Output];
        [API.V1AdminMenuUpdateRuleTime.url]: [
            API.V1AdminMenuUpdateRuleTime.Input,
            API.V1AdminMenuUpdateRuleTime.Output,
        ];
        [API.V1AdminOutletGetDetails.url]: [API.V1AdminOutletGetDetails.Input, API.V1AdminOutletGetDetails.Output];
        [API.V1AdminProductGet.url]: [API.V1AdminProductGet.Input, API.V1AdminProductGet.Output];
        [API.V1AdminProductReportCreateConsumptionReport.url]: [
            API.V1AdminProductReportCreateConsumptionReport.Input,
            API.V1AdminProductReportCreateConsumptionReport.Output,
        ];
        [API.V1AdminProductUpdate.url]: [API.V1AdminProductUpdate.Input, API.V1AdminProductUpdate.Output];
        [API.V1AdminProductUpdateValues.url]: [
            API.V1AdminProductUpdateValues.Input,
            API.V1AdminProductUpdateValues.Output,
        ];
        [API.V1AdminProductTagCreateOrUpdate.url]: [
            API.V1AdminProductTagCreateOrUpdate.Input,
            API.V1AdminProductTagCreateOrUpdate.Output,
        ];
        [API.V1AdminSpillageCreateReport.url]: [
            API.V1AdminSpillageCreateReport.Input,
            API.V1AdminSpillageCreateReport.Output,
        ];
        [API.V1AnalyticsTest.url]: [API.V1AnalyticsTest.Input, API.V1AnalyticsTest.Output];
        [API.V1ApiV1FindValue.url]: [API.V1ApiV1FindValue.Input, API.V1ApiV1FindValue.Output];
        [API.V1AppCheckoutCancelPayment.url]: [
            API.V1AppCheckoutCancelPayment.Input,
            API.V1AppCheckoutCancelPayment.Output,
        ];
        [API.V1AppCheckoutPreparePayment.url]: [
            API.V1AppCheckoutPreparePayment.Input,
            API.V1AppCheckoutPreparePayment.Output,
        ];
        [API.V1AppKioskClaimOrder.url]: [API.V1AppKioskClaimOrder.Input, API.V1AppKioskClaimOrder.Output];
        [API.V1AppKioskTerminalPaymentCancel.url]: [
            API.V1AppKioskTerminalPaymentCancel.Input,
            API.V1AppKioskTerminalPaymentCancel.Output,
        ];
        [API.V1AppKioskTerminalPaymentRequest.url]: [
            API.V1AppKioskTerminalPaymentRequest.Input,
            API.V1AppKioskTerminalPaymentRequest.Output,
        ];
        [API.V1AppPayGetLocks.url]: [API.V1AppPayGetLocks.Input, API.V1AppPayGetLocks.Output];
        [API.V1AppPayUpdateLocks.url]: [API.V1AppPayUpdateLocks.Input, API.V1AppPayUpdateLocks.Output];
        [API.V1AppPlaceOrder.url]: [API.V1AppPlaceOrder.Input, API.V1AppPlaceOrder.Output];
        [API.V1AppTableBootstrap.url]: [API.V1AppTableBootstrap.Input, API.V1AppTableBootstrap.Output];
        [API.V1AppTableGetZoneState.url]: [API.V1AppTableGetZoneState.Input, API.V1AppTableGetZoneState.Output];
        [API.V1AppTableUpdateValue.url]: [API.V1AppTableUpdateValue.Input, API.V1AppTableUpdateValue.Output];
        [API.V1AuthLogin.url]: [API.V1AuthLogin.Input, API.V1AuthLogin.Output];
        [API.V1IngredientAction.url]: [API.V1IngredientAction.Input, API.V1IngredientAction.Output];
        [API.V1IngredientGet.url]: [API.V1IngredientGet.Input, API.V1IngredientGet.Output];
        [API.V1IngredientManage.url]: [API.V1IngredientManage.Input, API.V1IngredientManage.Output];
        [API.V1IntegrationUpdateIntegration.url]: [
            API.V1IntegrationUpdateIntegration.Input,
            API.V1IntegrationUpdateIntegration.Output,
        ];
        [API.V1OperatorExportGetForm.url]: [API.V1OperatorExportGetForm.Input, API.V1OperatorExportGetForm.Output];
        [API.V1OperatorExportSubmit.url]: [API.V1OperatorExportSubmit.Input, API.V1OperatorExportSubmit.Output];
        [API.V1PosAnalyticsGetOverview.url]: [
            API.V1PosAnalyticsGetOverview.Input,
            API.V1PosAnalyticsGetOverview.Output,
        ];
        [API.V1PosAnalyticsGetOverviewDetails.url]: [
            API.V1PosAnalyticsGetOverviewDetails.Input,
            API.V1PosAnalyticsGetOverviewDetails.Output,
        ];
        [API.V1PosCourseBootstrap.url]: [API.V1PosCourseBootstrap.Input, API.V1PosCourseBootstrap.Output];
        [API.V1PosOutletBootstrap.url]: [API.V1PosOutletBootstrap.Input, API.V1PosOutletBootstrap.Output];
        [API.V1PosOutletCourseGetData.url]: [API.V1PosOutletCourseGetData.Input, API.V1PosOutletCourseGetData.Output];
        [API.V1PosOutletGetOrders.url]: [API.V1PosOutletGetOrders.Input, API.V1PosOutletGetOrders.Output];
        [API.V1PosOutletQueueLimiterGetData.url]: [
            API.V1PosOutletQueueLimiterGetData.Input,
            API.V1PosOutletQueueLimiterGetData.Output,
        ];
        [API.V1PosOutletTableGetState.url]: [API.V1PosOutletTableGetState.Input, API.V1PosOutletTableGetState.Output];
        [API.V1PosOutletTerminalGetPayment.url]: [
            API.V1PosOutletTerminalGetPayment.Input,
            API.V1PosOutletTerminalGetPayment.Output,
        ];
        [API.V1PosPaymentGetPaymentMethods.url]: [
            API.V1PosPaymentGetPaymentMethods.Input,
            API.V1PosPaymentGetPaymentMethods.Output,
        ];
        [API.V1PosPosGetData.url]: [API.V1PosPosGetData.Input, API.V1PosPosGetData.Output];
        [API.V1PosPosGetHistory.url]: [API.V1PosPosGetHistory.Input, API.V1PosPosGetHistory.Output];
        [API.V1PosStationGetOrders.url]: [API.V1PosStationGetOrders.Input, API.V1PosStationGetOrders.Output];
        [API.V1PosStationIngredientUpdate.url]: [
            API.V1PosStationIngredientUpdate.Input,
            API.V1PosStationIngredientUpdate.Output,
        ];
        [API.V1PosStationRequest.url]: [API.V1PosStationRequest.Input, API.V1PosStationRequest.Output];
        [API.V1PosUserGetLocations.url]: [API.V1PosUserGetLocations.Input, API.V1PosUserGetLocations.Output];
        [API.V1PosZoneDialogBootstrap.url]: [API.V1PosZoneDialogBootstrap.Input, API.V1PosZoneDialogBootstrap.Output];
        [API.V1PosZoneGetDetails.url]: [API.V1PosZoneGetDetails.Input, API.V1PosZoneGetDetails.Output];
        [API.V1PosZoneGetList.url]: [API.V1PosZoneGetList.Input, API.V1PosZoneGetList.Output];
        [API.V1PosZoneLegacyGetZoneData.url]: [
            API.V1PosZoneLegacyGetZoneData.Input,
            API.V1PosZoneLegacyGetZoneData.Output,
        ];
        [API.V1ProductGet.url]: [API.V1ProductGet.Input, API.V1ProductGet.Output];
        [API.V1ProductI18NGet.url]: [API.V1ProductI18NGet.Input, API.V1ProductI18NGet.Output];
        [API.V1ProductI18NUpdate.url]: [API.V1ProductI18NUpdate.Input, API.V1ProductI18NUpdate.Output];
        [API.V1Provider24SevenOfficeAssignCategoryToAccount.url]: [
            API.V1Provider24SevenOfficeAssignCategoryToAccount.Input,
            API.V1Provider24SevenOfficeAssignCategoryToAccount.Output,
        ];
        [API.V1Provider24SevenOfficeGetAccountData.url]: [
            API.V1Provider24SevenOfficeGetAccountData.Input,
            API.V1Provider24SevenOfficeGetAccountData.Output,
        ];
        [API.V1Provider24SevenOfficeGetAccountMappings.url]: [
            API.V1Provider24SevenOfficeGetAccountMappings.Input,
            API.V1Provider24SevenOfficeGetAccountMappings.Output,
        ];
        [API.V1Provider24SevenOfficeGetCustomers.url]: [
            API.V1Provider24SevenOfficeGetCustomers.Input,
            API.V1Provider24SevenOfficeGetCustomers.Output,
        ];
        [API.V1Provider24SevenOfficeGetSettings.url]: [
            API.V1Provider24SevenOfficeGetSettings.Input,
            API.V1Provider24SevenOfficeGetSettings.Output,
        ];
        [API.V1Provider24SevenOfficeGetSettlementSyncData.url]: [
            API.V1Provider24SevenOfficeGetSettlementSyncData.Input,
            API.V1Provider24SevenOfficeGetSettlementSyncData.Output,
        ];
        [API.V1ProviderAdyenWebhookPayment.url]: [
            API.V1ProviderAdyenWebhookPayment.Input,
            API.V1ProviderAdyenWebhookPayment.Output,
        ];
        [API.V1ProviderAdyenWebhookTransaction.url]: [
            API.V1ProviderAdyenWebhookTransaction.Input,
            API.V1ProviderAdyenWebhookTransaction.Output,
        ];
        [API.V1ProviderAwsGetIotUrl.url]: [API.V1ProviderAwsGetIotUrl.Input, API.V1ProviderAwsGetIotUrl.Output];
        [API.V1ProviderAzureQueueSendTestOrder.url]: [
            API.V1ProviderAzureQueueSendTestOrder.Input,
            API.V1ProviderAzureQueueSendTestOrder.Output,
        ];
        [API.V1ProviderAzureQueueTestConnection.url]: [
            API.V1ProviderAzureQueueTestConnection.Input,
            API.V1ProviderAzureQueueTestConnection.Output,
        ];
        [API.V1ProviderTripletexAutoMatchAccounts.url]: [
            API.V1ProviderTripletexAutoMatchAccounts.Input,
            API.V1ProviderTripletexAutoMatchAccounts.Output,
        ];
        [API.V1ProviderTripletexGetAccountMappings.url]: [
            API.V1ProviderTripletexGetAccountMappings.Input,
            API.V1ProviderTripletexGetAccountMappings.Output,
        ];
        [API.V1ProviderTripletexGetCustomers.url]: [
            API.V1ProviderTripletexGetCustomers.Input,
            API.V1ProviderTripletexGetCustomers.Output,
        ];
        [API.V1ProviderTripletexTestConnection.url]: [
            API.V1ProviderTripletexTestConnection.Input,
            API.V1ProviderTripletexTestConnection.Output,
        ];
        [API.V1ProviderVisbookPutOnRoom.url]: [
            API.V1ProviderVisbookPutOnRoom.Input,
            API.V1ProviderVisbookPutOnRoom.Output,
        ];
        [API.V1ProviderVisbookRemoveFromRoom.url]: [
            API.V1ProviderVisbookRemoveFromRoom.Input,
            API.V1ProviderVisbookRemoveFromRoom.Output,
        ];
        [API.V1ProviderVisbookTestConnection.url]: [
            API.V1ProviderVisbookTestConnection.Input,
            API.V1ProviderVisbookTestConnection.Output,
        ];
        [API.V1ProviderVisbookUpdateAndGetSetup.url]: [
            API.V1ProviderVisbookUpdateAndGetSetup.Input,
            API.V1ProviderVisbookUpdateAndGetSetup.Output,
        ];
        [API.V1ReportsSales.url]: [API.V1ReportsSales.Input, API.V1ReportsSales.Output];
        [API.V1SaAdyenCreateBalanceAccount.url]: [
            API.V1SaAdyenCreateBalanceAccount.Input,
            API.V1SaAdyenCreateBalanceAccount.Output,
        ];
        [API.V1SaAdyenCreateLegalEntity.url]: [
            API.V1SaAdyenCreateLegalEntity.Input,
            API.V1SaAdyenCreateLegalEntity.Output,
        ];
        [API.V1SaAdyenCreateStore.url]: [API.V1SaAdyenCreateStore.Input, API.V1SaAdyenCreateStore.Output];
        [API.V1SaAdyenGetBalanceHistory.url]: [
            API.V1SaAdyenGetBalanceHistory.Input,
            API.V1SaAdyenGetBalanceHistory.Output,
        ];
        [API.V1SaAdyenGetCompanies.url]: [API.V1SaAdyenGetCompanies.Input, API.V1SaAdyenGetCompanies.Output];
        [API.V1SaAdyenGetCompanyDetails.url]: [
            API.V1SaAdyenGetCompanyDetails.Input,
            API.V1SaAdyenGetCompanyDetails.Output,
        ];
        [API.V1SaAdyenTerminalsGet.url]: [API.V1SaAdyenTerminalsGet.Input, API.V1SaAdyenTerminalsGet.Output];
        [API.V1SaAdyenUpdateAccountHolderBalances.url]: [
            API.V1SaAdyenUpdateAccountHolderBalances.Input,
            API.V1SaAdyenUpdateAccountHolderBalances.Output,
        ];
        [API.V1SaDashboardGetData.url]: [API.V1SaDashboardGetData.Input, API.V1SaDashboardGetData.Output];
        [API.V1SaModificationGet.url]: [API.V1SaModificationGet.Input, API.V1SaModificationGet.Output];
        [API.V1SaModificationUpdate.url]: [API.V1SaModificationUpdate.Input, API.V1SaModificationUpdate.Output];
        [API.V1SaProfitGetReport.url]: [API.V1SaProfitGetReport.Input, API.V1SaProfitGetReport.Output];
        [API.V1SaProfitGetTransactionPerformance.url]: [
            API.V1SaProfitGetTransactionPerformance.Input,
            API.V1SaProfitGetTransactionPerformance.Output,
        ];
        [API.V1SaUserGet.url]: [API.V1SaUserGet.Input, API.V1SaUserGet.Output];
        [API.V1SettlementAnalyseSettlement.url]: [
            API.V1SettlementAnalyseSettlement.Input,
            API.V1SettlementAnalyseSettlement.Output,
        ];
        [API.V1SettlementCreateReport.url]: [API.V1SettlementCreateReport.Input, API.V1SettlementCreateReport.Output];
        [API.V1SettlementGetHistory.url]: [API.V1SettlementGetHistory.Input, API.V1SettlementGetHistory.Output];
        [API.V1SettlementGetPendingSettlement.url]: [
            API.V1SettlementGetPendingSettlement.Input,
            API.V1SettlementGetPendingSettlement.Output,
        ];
        [API.V1SettlementGetSettlementSyncData.url]: [
            API.V1SettlementGetSettlementSyncData.Input,
            API.V1SettlementGetSettlementSyncData.Output,
        ];
        [API.V1SettlementPayoutCreate.url]: [API.V1SettlementPayoutCreate.Input, API.V1SettlementPayoutCreate.Output];
        [API.V1SettlementProviderMarkAsManuallyHandled.url]: [
            API.V1SettlementProviderMarkAsManuallyHandled.Input,
            API.V1SettlementProviderMarkAsManuallyHandled.Output,
        ];
        [API.V1SettlementReportCreate.url]: [API.V1SettlementReportCreate.Input, API.V1SettlementReportCreate.Output];
        [API.V1SettlementReportDownload.url]: [
            API.V1SettlementReportDownload.Input,
            API.V1SettlementReportDownload.Output,
        ];
        [API.V1SettlementSendSettlement.url]: [
            API.V1SettlementSendSettlement.Input,
            API.V1SettlementSendSettlement.Output,
        ];
        [API.V1SocketEmit.url]: [API.V1SocketEmit.Input, API.V1SocketEmit.Output];
        [API.V1StationGet.url]: [API.V1StationGet.Input, API.V1StationGet.Output];
        [API.V1StationManage.url]: [API.V1StationManage.Input, API.V1StationManage.Output];
        [API.V1StationManageProducts.url]: [API.V1StationManageProducts.Input, API.V1StationManageProducts.Output];
        [API.V1UserAuthenticate.url]: [API.V1UserAuthenticate.Input, API.V1UserAuthenticate.Output];
        [API.V1UserMe.url]: [API.V1UserMe.Input, API.V1UserMe.Output];
        [API.V1ZoneGroupCreateOrUpdate.url]: [
            API.V1ZoneGroupCreateOrUpdate.Input,
            API.V1ZoneGroupCreateOrUpdate.Output,
        ];
        [API.V1ZoneGroupGetDetails.url]: [API.V1ZoneGroupGetDetails.Input, API.V1ZoneGroupGetDetails.Output];
        [API.V1ZoneGroupRemove.url]: [API.V1ZoneGroupRemove.Input, API.V1ZoneGroupRemove.Output];
        [API.V1ZReportGetZReports.url]: [API.V1ZReportGetZReports.Input, API.V1ZReportGetZReports.Output];
        [API.V1ZReportGetZReportSummary.url]: [
            API.V1ZReportGetZReportSummary.Input,
            API.V1ZReportGetZReportSummary.Output,
        ];
        [API.V2PosDeviceBootstrap.url]: [API.V2PosDeviceBootstrap.Input, API.V2PosDeviceBootstrap.Output];
        [API.V2PosDeviceConfirm.url]: [API.V2PosDeviceConfirm.Input, API.V2PosDeviceConfirm.Output];
        [API.V2PosDeviceEventSend.url]: [API.V2PosDeviceEventSend.Input, API.V2PosDeviceEventSend.Output];
        [API.V2PosDeviceSettle.url]: [API.V2PosDeviceSettle.Input, API.V2PosDeviceSettle.Output];
        [API.V2PosPaymentDialogBootstrap.url]: [
            API.V2PosPaymentDialogBootstrap.Input,
            API.V2PosPaymentDialogBootstrap.Output,
        ];
        [API.V2PosStationGetData.url]: [API.V2PosStationGetData.Input, API.V2PosStationGetData.Output];
        [API.V2PosStationGetOrder.url]: [API.V2PosStationGetOrder.Input, API.V2PosStationGetOrder.Output];
        [API.Version.url]: [API.Version.Input, API.Version.Output];
    };

    export async function req<U extends keyof API_IO>(url: U, input: API_IO[U][0], config?): Promise<API_IO[U][1]> {
        const baseURL =
            process.env.NODE_ENV === 'production' || localStorage.getItem('isLive')
                ? 'https://api-v2.orderx.eu'
                : `${window.location.protocol}//${window.location.hostname}:9005`;

        const token = localStorage.getItem('token')?.replace?.(/"/g, '');

        let fp;

        try {
            fp = JSON.parse(localStorage.getItem('Device$') || '')?.fingerprint;
        } catch (error) {}

        return axios
            .post(url, input, {
                baseURL,
                ...config,
                headers: {
                    token: token,
                    'device-fingerprint': fp || localStorage.deviceFingerprint?.replace(/"/g, ''),
                    'app-version': process.env.REACT_APP_DEPLOYED_AT,
                    latitude: localStorage.getItem('api_header_latitude'),
                    longitude: localStorage.getItem('api_header_longitude'),
                },
            })
            .then((result) => result.data);
    }
}

export enum AccountType {
    SALES = 'SALES',
    PURCHASE = 'PURCHASE',
    DISCOUNT = 'DISCOUNT',
    SERVICE_FEE = 'SERVICE_FEE',
    SPILLAGE = 'SPILLAGE',
}
export type Account = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    code: string;
    vatPercent: number;
    type: AccountType;
    externalId: string;
    location: Location;
    locationId: number;
    products: Product[];
    purchaseAccountProducts: Product[];
    takeawayAccountProducts: Product[];
    discounts: Discount[];
    productAccounts: ProductAccount[];
};
export enum AdyenAccountHolderEnvironment {
    TEST = 'TEST',
    LIVE = 'LIVE',
}
export type AdyenAccountHolderPayoutStatus = 'Active' | 'Closed' | 'Inactive' | 'Suspended' | string;
export type AdyenAccountHolder = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    code: string;
    status: AdyenAccountHolderPayoutStatus;
    statusReason: string;
    payoutAllowed: boolean;
    payoutNotAllowedReason: string;
    payoutDisabled: boolean;
    payoutDisabledReason: string;
    environment: AdyenAccountHolderEnvironment;
    company: Company;
    companyId: number;
    adyenAccounts: AdyenAccount[];
    balances: AdyenBalance[];
};
export type AdyenAccount = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    code: string;
    locations: Location[];
    adyenAccountHolder: AdyenAccountHolder;
    adyenAccountHolderId: number;
};
export type AdyenEvent = {
    id: string;
    createdAt: Date;
};
export type AdyenNotificationPlatform = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    eventDate: string;
    eventType: string;
    pspReference: string;
    live: boolean;
    accountCode: string;
    merchantAccountCode: string;
    data: any;
};
export type AdyenNotificationTerminalEventToNotify =
    | 'BeginMaintenance'
    | 'EndMaintenance'
    | 'Shutdown'
    | 'Initialised'
    | 'OutOfOrder'
    | 'Completed'
    | 'Abort'
    | 'SaleWakeUp'
    | 'SaleAdmin'
    | 'CustomerLanguage'
    | 'KeyPressed'
    | 'SecurityAlarm'
    | 'StopAssistance'
    | 'CardInserted'
    | 'CardRemoved'
    | 'Reject';
export type AdyenNotificationTerminal = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    pOIID: string;
    saleID: string;
    deviceID: string;
    serviceID: string;
    messageType: string;
    messageClass: string;
    messageCategory: string;
    protocolVersion: string;
    timeStamp: string;
    eventDetails: string;
    rejectedMessage: string;
    eventToNotify: AdyenNotificationTerminalEventToNotify | string;
    data: any;
    terminal: Terminal;
    terminalId: number;
};
export enum AdyenNotificationWebhookType {
    BANK_TRANSFER_PENDING = 'BANK_TRANSFER_PENDING',
    REPORT = 'REPORT',
    STANDARD = 'STANDARD',
    TERMINAL = 'TERMINAL',
}
export type AdyenNotification = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    webhookType: AdyenNotificationWebhookType;
    eventCode: string;
    success: boolean;
    reason: string;
    eventDate: string;
    merchantAccountCode: string;
    amount: { currency: string; value: string };
    paymentMethod: string;
    merchantReference: string;
    pspReference: string;
    live: boolean;
    additionalData: any;
    notificationRequestItem: any;
};
export type AdyenPayoutStatus =
    | string
    | 'SUCCESS'
    | 'PAYOUT_THIRDPARTY'
    | 'PAYOUT_DECLINE'
    | 'PAYOUT_EXPIRE'
    | 'PAIDOUT_REVERSED';
export type AdyenPayoutPayoutParams = {
    accountCode: string;
    accountHolderCode: string;
    description: string;
    amount: number;
    currency: string;
    bankAccountUUID: string;
};
export type AdyenPayout = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    merchantReference: string;
    guid: string;
    amount: number;
    currency: string;
    accountCode: string;
    accountHolderCode: string;
    bankAccountIban: string;
    bankAccountUuid: string;
    status: AdyenPayoutStatus;
    statusReason: string;
    payoutParams: AdyenPayoutPayoutParams;
    payoutAccountHolderResponse: any;
    notificationCallbacks: any[];
    company: Company;
    companyId: number;
    location: Location;
    locationId: number;
    payments: Payment[];
    settlements: Settlement[];
    zReport: ZReport;
};
export type AdyenStore = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    merchantAccount: string;
    merchantCategoryCode: string;
    storeReference: string;
    store?: string;
    storeName?: string;
    fullPhoneNumber?: string;
    phoneAreaCode?: string;
    phone?: string;
    addressCountry?: string;
    addressCity?: string;
    addressStreet?: string;
    addressHouseNumberOrName?: string;
    addressPostalCode?: string;
    location: Location;
};
export type AdyenBalance = {
    id: number;
    accountHolder: AdyenAccountHolder;
    accountHolderId: number;
    amount: number;
    amountPending: number;
    amountHold: number;
    response: any;
    isVisible: boolean;
    createdAt: Date;
};
export enum AnalyticsSaleItemType {
    REVENUE = 'REVENUE',
    TIP = 'TIP',
    SERVICE_FEE = 'SERVICE_FEE',
}
export type AnalyticsSaleItem = {
    id: string;
    groupingId: string;
    orderId: number;
    createdAt: Date;
    name: string;
    type: AnalyticsSaleItemType;
    locationId: number;
    locationName: string;
    outletId: number;
    outletName: string;
    zoneId: number;
    zoneName: string;
    priceExcludingVat: number;
    priceVat: number;
    price: number;
    date: Date;
    dateMonth: string;
    dateDay: string;
    dateHour: string;
    dateMinute: string;
};
export type BalanceClaim = {
    id: number;
    balance: Balance;
    balanceId: number;
    areaCode: string;
    phone: string;
};
export type BalanceProduct = {
    balance: Balance;
    balanceId: number;
    product: Product;
    productId: number;
    count: number;
};
export enum BalanceType {
    CREDIT = 'CREDIT',
    INVOICE = 'INVOICE',
}
export type Balance = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    hash?: string;
    name?: string;
    namePayment?: string;
    namePublic?: string;
    nameInternal?: string;
    type?: BalanceType;
    amountInitial: number;
    amountRemaining: number;
    isActive: boolean;
    validFrom?: Date;
    validTo?: Date;
    client: Client;
    clientId?: number;
    userBalances: UserBalance[];
    balanceProducts: BalanceProduct[];
    balanceClaims: BalanceClaim[];
    payments: Payment[];
    locationBalances: LocationBalance[];
};
export type BaseModel = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
};
export type Cache = {
    id: string;
    value: any;
    createdAt: Date;
    updatedAt: Date;
};
export type ClientInvoice = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    ref: string;
    amount: number;
    periodFrom: Date;
    periodTo: Date;
    isInvoiced: boolean;
    customFields?: { key: string; value: string }[];
    client: Client;
    clientId: number;
    payments: Payment[];
};
export type ClientType = 'representation';
export type Client = {
    id: number;
    name: string;
    type?: ClientType;
    isActive: boolean;
    description: string;
    contactName: string;
    contactEmail: string;
    companyRegNr: string;
    location: Location;
    locationId: number;
    group: ClientGroup;
    groupId?: number;
    createdAt: Date;
    updatedAt: Date;
    balances: Balance[];
    clientInvoices: ClientInvoice[];
    clientDiscounts: ClientDiscount[];
};
export type ClientDiscount = {
    client: Client;
    clientId: number;
    discount: Discount;
    discountId: number;
};
export type ClientGroup = {
    id: number;
    name: string;
    externalProvider?: 'tripletex' | '24_seven_office' | string;
    externalProviderCustomerId?: number;
    tripletexCustomerId?: number;
    location: Location;
    locationId: number;
    clients: Client[];
};
export enum CompanyMode {
    TEST = 'TEST',
    LIVE = 'LIVE',
}
export type Company = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    mode: CompanyMode;
    countryCode: string;
    currencyCode: string;
    email: string;
    legalAddress: string;
    registrationNumber: string;
    addressRegion: string;
    addressCity: string;
    addressStreetName: string;
    addressStreetNumber: string;
    addressStreetPostalCode: string;
    locations: Location[];
    adyenAccountHolders: AdyenAccountHolder[];
    adyenPayouts: AdyenPayout[];
    userCompanyRoles: UserCompanyRole[];
    terminals: Terminal[];
    externalId: string;
    adyenLegalEntityId: string;
    adyenAccountHolderId: string;
    country: string;
};
export enum ConfigId {
    ADYEN_CONFIG_TEST = 'ADYEN_CONFIG_TEST',
    ADYEN_CONFIG_LIVE = 'ADYEN_CONFIG_LIVE',
    ADYEN_CONFIG = 'ADYEN_CONFIG',
    Z_REPORT_START_DATE = 'Z_REPORT_START_DATE',
    POS_VERSION = 'POS_VERSION',
}
export type ConfigDataAdyenConfig = {
    accountCodeTransactionFee: string;
    accountCodeServiceFee: string;
    environment: 'LIVE' | 'TEST';
    merchantAccountPlatforms: string;
    merchantAccountPos: string;
    userReport: {
        userName: string;
        apiKey: string;
        password: string;
    };
    userWebService: {
        userName: string;
        apiKey: string;
        clientKey: string;
        basicAuthPassword: string;
        basicAuthPosPassword: string;
    };
    userPlatform: {
        userName: string;
        apiKey: string;
    };
    googlePayMerchantId?: string;
    liveEndpointUrlPrefix?: string;
    /**
     * @deprecated
     */
    accountCodeLiableAccount: string;
};
export type ConfigData = ConfigDataAdyenConfig | any;
export type Config = {
    id: ConfigId;
    data: ConfigData;
};
export type Course = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    position: number;
    location: Location;
    locationId: number;
    products: Product[];
    orderProducts: OrderProduct[];
    modifierGroupItems: ModifierGroupItem[];
};
export type CovidRegistration = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    areaCode: string;
    phone: string;
    deviceFingerprint: string;
    zoneId: number;
    zoneName: string;
    user: User;
    userId: number;
    outlet: Outlet;
    outletId: number;
    outletName: string;
    locationId: number;
    locationName: string;
};
export type Cron = {
    id: string;
    pattern: string;
    isActive: boolean;
    isMaxMemory: boolean;
};
export type DiscountProduct = {
    discount: Discount;
    discountId: number;
    product: Product;
    productId: number;
    percent: number;
};
export type DiscountUser = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    discount: Discount;
    discountId: number;
    user: User;
    userId: number;
};
export type Discount = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    displayName: string;
    percent: number;
    validFrom: Date;
    validTo: Date;
    hoursValidFor: number;
    revokedAt: Date;
    location: Location;
    locationId: number;
    account: Account;
    accountId: number;
    discountProducts: DiscountProduct[];
    discountUsers: DiscountUser[];
    clientDiscounts: ClientDiscount[];
};
export type EJournalCashRegister = {
    registerID: string;
    description: string;
    cashTransactions: EJournalCashTransaction[];
    createdAt: Date;
    updatedAt: Date;
};
export type ECSequentialNumber = number;
export type ECTotalSalesIncludingVat = number;
export type ECTotalSalesExcludingVat = number;
export type ECYearMonthDay = string;
export type ECHoursMinutesSeconds = string;
export type ECDecimalPrecision2 = string;
export enum EJournalCashTransactionAmountType {
    DEBIT = 'D',
    CREDIT = 'C',
}
export enum EJournalCashTransactionKeyVersion {
    E_JOURNAL_KEY_V1 = 'eJournalKey.V1',
}
export type EJournalCashTransactionCtLine = {
    nr: ECSequentialNumber;
    // Transaction line number. Should be a unique sequential number within a transaction.
    lineID: any;
    // Reference to ticketline codes. Description of the code must be stated in the table 'Basics'.
    // lineType: any;
    lineAmntIn: ECDecimalPrecision2;
    lineAmntEx: ECDecimalPrecision2;
    amntTp: EJournalCashTransactionAmountType;
    cashTransLineDescr: string;
    vat: {
        vatCode: any;
        vatPerc: ECDecimalPrecision2;
        vatAmnt: ECDecimalPrecision2;
    };
};
export type EJournalCashTransaction = {
    id: string;
    nr: ECSequentialNumber;
    transID: ECSequentialNumber;
    transAmntIn: ECDecimalPrecision2;
    transAmntEx: ECDecimalPrecision2;
    amntTp: EJournalCashTransactionAmountType;
    transDate: ECYearMonthDay;
    transTime: ECHoursMinutesSeconds;
    signature: string;
    keyVersion: EJournalCashTransactionKeyVersion;
    payment: Payment;
    order: Order;
    cashRegister: EJournalCashRegister;
    registerID: string;
    ctLine: EJournalCashTransactionCtLine[];
    createdAt: Date;
    updatedAt: Date;
    eventEJournalCashTransactions: SettlementEventEJournalCashTransaction[];
};
export type EJournalEventReportArticleGroup = {
    artGroupID: number; // account ID
    artGroupNum: number; // precision 2; total sales count
    artGroupAmnt: number; // precision 2; total sales including VAT
    accDesc?: string;
};
export type EJournalEventReportReportPayment = {
    paymentType: string;
    paymentNum: number; // precision 2; total sales count
    paymentAmnt: number; // precision 2; total sales including VAT
};
export type EJournalEventReportVatGroup = {
    vatPerc: number;
    cashSaleAmnt: number; // precision 2; total sales excluding VAT
    vatAmnt: number; // precision 2; total sales VAT
};
export enum EJournalEventReportReportType {
    Z_REPORT = 'Z report',
    X_REPORT = 'X report',
}
export type EJournalEventReportReportTotalCashSales = {
    totalCashSaleAmnt: number; // TerminalTotalSalesIncludingVat
};
type EJournalEventReportReportCorrLines = {
    corrLineType: null;
    corrLineNum: 0;
    corrLineAmnt: 0.0;
};
type EJrounalEventReportReportPriceInquiries = {
    priceInquiryGroup: null;
    priceInquiryNum: 0;
    priceInquiryAmnt: 0.0;
};
type EJrounalEventReportReportReportOtherCorrs = {
    otherCorrType: null;
    otherCorrNum: 0;
    otherCorrAmnt: 0.0;
};
export type EJournalEventReport = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    eventID: string;
    eventType: string;
    eventDate: string | '2020-01-01';
    eventTime: string | '00:00:00';
    reportID: number; // SettlementSequenceNumber
    reportType: EJournalEventReportReportType;
    companyIdent: string; // CompanyRegNumber
    companyName: string;
    reportDate: string | '2020-01-01';
    reportTime: string | '00:00:00';
    registerID: string; // CashRegisterId
    reportTotalCashSales: EJournalEventReportReportTotalCashSales;
    reportArtGroups: EJournalEventReportArticleGroup[];
    reportPayments: EJournalEventReportReportPayment[];
    reportCashSalesVat: EJournalEventReportVatGroup[];
    reportOpeningChangeFloat: number;
    reportReceiptNum: number;
    reportOpenCashBoxNum: number;
    reportReceiptCopyNum: number;
    reportReceiptCopyAmnt: number;
    reportReceiptProformaNum: number;
    reportReceiptProformaAmnt: number;
    reportReturnNum: number;
    reportReturnAmnt: number;
    reportDiscountNum: number;
    reportDiscountAmnt: number;
    reportVoidTransNum: number;
    reportVoidTransAmnt: number;
    reportCorrLines: EJournalEventReportReportCorrLines[];
    reportPriceInquiries: EJrounalEventReportReportPriceInquiries[];
    reportOtherCorrs: EJrounalEventReportReportReportOtherCorrs[];
    reportReceiptDeliveryNum: number;
    reportReceiptDeliveryAmnt: number;
    reportTrainingNum: number;
    reportTrainingAmnt: number;
    reportGrandTotalSales: number; // TerminalTotalSalesIncludingVat
    reportGrandTotalReturn: number;
    reportGrandTotalSalesNet: number; // TerminalTotalSalesExcludingVat
    settlement: Settlement;
    settlementId: number;
    eventEJournalEventReports: SettlementEventEJournalEventReport[];
};
export enum EventHistoryType {
    OUTLET_OPENING_TIME = 'OUTLET_OPENING_TIME',
    OUTLET_CHANGE_MENU = 'OUTLET_CHANGE_MENU',
    SETTLEMENT_S3_DATA_QUERY = 'SETTLEMENT_S3_DATA_QUERY',
    SETTLEMENT_ADYEN_PAYOUT_REQUIRED_QUERY = 'SETTLEMENT_ADYEN_PAYOUT_REQUIRED_QUERY',
    SETTLEMENT_VISMA_SYNC = 'SETTLEMENT_VISMA_SYNC',
    ORDER_MUNU_SYNC = 'ORDER_MUNU_SYNC',
    SETTLEMENT_AUTO_SETTLE = 'SETTLEMENT_AUTO_SETTLE',
    SETTLEMENT_AUTO_PAY_OUT = 'SETTLEMENT_AUTO_PAY_OUT',
    EMAIL_SYSTEM_REPORT = 'EMAIL_SYSTEM_REPORT',
    EMAIL = 'EMAIL',
}
export type EventHistory = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    eventId: string;
    idValue: number;
    outletId: number;
    data: any;
    type: EventHistoryType;
};
export type ExternalRequestType =
    | 'AZURE_SEND_TO_STORAGE_QUEUE'
    | 'SYNC_ARCHIVED_ORDER'
    | 'TRIPLETEX_SEND_INVOICE'
    | '24_SEVEN_OFFICE_SEND_INVOICE'
    | 'EMAIL';
export type ExternalRequestResponseStatus = 'error' | 'success';
export type ExternalRequest = {
    id: number;
    type: ExternalRequestType;
    numValue: number;
    strValue: string;
    request: any;
    response: any;
    responseStatus: ExternalRequestResponseStatus;
    location: Location;
    locationId: number;
    createdAt: Date;
};
export enum FeatureType {
    ADMIN_V2_ACCESS = 'ADMIN_V2_ACCESS',
    ZONE_PAY = 'ZONE_PAY',
    POS_BALANCE = 'POS_BALANCE',
    POS_MARK_AS_PAID = 'POS_MARK_AS_PAID',
    POS_MODULE = 'POS_MODULE',
    POS_LOCATION_OPERATOR = 'POS_LOCATION_OPERATOR',
    POS_DISCOUNT_CUSTOM = 'POS_DISCOUNT_CUSTOM',
    POS_COURSE_V2 = 'POS_COURSE_V2',
    POS_ZONE_LIST_COURSE_DIALOG_V2 = 'POS_ZONE_LIST_COURSE_DIALOG_V2',
    POS_OUTLET_V2 = 'POS_OUTLET_V2',
    POS_ZONES_V2 = 'POS_ZONES_V2',
    POS_STATION_V2 = 'POS_STATION_V2',
    POS_POS_V2 = 'POS_POS_V2',
    POS_IOT_V2 = 'POS_IOT_V2',
    POS_PAYMENT_BALANCE = 'POS_PAYMENT_BALANCE',
    POS_LAYOUT = 'POS_LAYOUT',
    POS_TERMINAL_PAYMENT_FORCE_SELECT_ZONE_FOR_FOOD_AND_OTHER = 'POS_TERMINAL_PAYMENT_FORCE_SELECT_ZONE_FOR_FOOD_AND_OTHER',
    POS_ANALYTICS_V2 = 'POS_ANALYTICS_V2',
    POS_ZONE_DIALOG = 'POS_ZONE_DIALOG',
    SETTLEMENT_DAILY = 'SETTLEMENT_DAILY',
    PAYMENT_METHOD_GIFT_CARD = 'PAYMENT_METHOD_GIFT_CARD',
    SPILLAGE = 'SPILLAGE',
    GIFT_CARD_REQUIRE_CODE = 'GIFT_CARD_REQUIRE_CODE',
    CUSTOM_PAYMENT_METHODS = 'CUSTOM_PAYMENT_METHODS',
    API_ORDER_ZONE_TERMINAL_DRINK_TO_DELIVERED = 'API_ORDER_ZONE_TERMINAL_DRINK_TO_DELIVERED',
}
export type Feature = {
    id: number;
    type: FeatureType;
    name?: string;
    description?: string;
    isActive: boolean;
    location: Location;
    locationId: number;
};
export type I18nLang = 'en' | 'no' | string;
export type I18nEntity = 'Product';
export type I18n = {
    id: number;
    lang: I18nLang;
    key: string;
    value: string;
    entity: I18nEntity;
    entityId: number;
    location: Location;
    locationId: number;
};
export type Ingredient = {
    id: number;
    name: string;
    location: Location;
    locationId: number;
    productIngredients: ProductIngredient[];
    stationIngredients: StationIngredient[];
    orderProductIngredients: OrderProductIngredient[];
};
export enum IntegrationType {
    KDR_OPEN = 'KDR_OPEN',
    VISMA = 'VISMA',
    MUNU = 'MUNU',
    TRIPLETEX = 'TRIPLETEX',
    VISBOOK = 'VISBOOK',
    SEVEN_OFFICE_24 = 'SEVEN_OFFICE_24',
    AZURE_QUEUE = 'AZURE_QUEUE',
}
export type IntegrationData =
    | IntegrationDataKdrOpen
    | IntegrationDataVisma
    | IntegrationDataMunu
    | IntegrationDataTripletex
    | IntegrationDataVisbook
    | IntegrationData24SevenOffice
    | IntegrationDataAzureQueue
    | any;
export type IntegrationDataKdrOpen = {
    origin: string;
    merchantId: string;
    userId: string;
    departmentId: string;
    partnerId: string;
    menuId: number;
    isActive: boolean;
    outletData: {
        [outletId: number]: {
            departmentId: string;
            menuId: number;
        };
    };
};
export type IntegrationDataVisma = {
    apiUrl: string;
    username: string;
    password: string;
    voucherSeriesNo?: number;
    voucherType?: number;
    accountType?: number;
    account?: {
        [key: string]: {
            code?: string;
            type?: 'CREDIT' | 'DEBIT';
        };
    };
};
export type IntegrationDataMunu = {
    clientId?: string;
    clientSecret?: string;
    tokenUrl?: string;
    baseUrl?: string;
    articleToProductIdMap?: Record<number, number>;
    syncMenuPrices?: boolean;
};
export type IntegrationDataTripletex = {
    consumerToken: string;
    employeeToken: string;
    baseUrl?: string;
    tripletexAccount: {
        [key: string]: {
            displayName: string;
            number: number;
            type: 'DEBIT' | 'CREDIT';
        };
    };
    isConnected?: boolean;
    autoSyncActive?: boolean;
};
export type IntegrationDataVisbook = {
    credentials: {
        username: string;
        password: string;
        companyId: number;
    };
    isConnected?: boolean;
    isValidConfiguration?: boolean;
    accountUnitMap?: Record<string, number>;
};
export type IntegrationData24SevenOffice = {
    isConnected?: boolean;
    credentials: {
        applicationId: string;
        username: string;
        password: string;
    };
    accountMap?: Record<
        string,
        {
            id: number;
            number: number;
            type?: 'CREDIT' | 'DEBIT';
            taxNo?: string;
        }
    >;
    typeId?: number;
    autoSyncActive?: boolean;
    autoSyncAccounts?: boolean;
    accountCategoryMap?: Record<string, number>;
};
export type IntegrationDataAzureQueue = {
    connectionString?: string;
    queueName?: string;
    isConnected?: boolean;
    autoSyncActive?: boolean;
};
export type Integration = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: IntegrationType;
    isActive: boolean;
    data: IntegrationData;
    location: Location;
    locationId: number;
};
export type InventoryActionDataProcessPurchaseOrderProduct = {
    unitAmount: number;
    containerPrice: number;
    purchaseOrderId: number;
    productId: number;
    inventoryId: number;
    meta?: any;
};
export type InventoryActionDataProcessCountingReportProduct = {
    unitAmountCorrection: number;
    unitAmountBefore: number;
    unitAmountAfter: number;
    productId: number;
    inventoryId: number;
    meta?: any;
    countingReportId: number;
};
export type InventoryActionDataInventoryMoveProduct = {
    productId: number;
    unitAmount: number;
    sourceInventoryId: number;
    sourceInventory: Inventory;
    targetInventoryId: number;
    targetInventory: Inventory;
    meta?: any;
};
export type InventoryActionDataProcessInventoryMoveProduct = {
    unitAmountCorrection: number;
    unitAmountBefore: number;
    unitAmountAfter: number;
    productId: number;
    product: Product;
    sourceInventory: Inventory;
    targetInventory: Inventory;
};
export enum InventoryActionType {
    INVENTORY_MOVE_CREATE = 'INVENTORY_MOVE_CREATE',
    INVENTORY_MOVE_PRODUCT_PROCESS = 'INVENTORY_MOVE_PRODUCT_PROCESS',
    PURCHASE_ORDER_PRODUCT_PROCESS = 'PURCHASE_ORDER_PRODUCT_PROCESS',
    COUNTING_REPORT_PRODUCT_PROCESS = 'COUNTING_REPORT_PRODUCT_PROCESS',
}
export type InventoryAction = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: InventoryActionType;
    description: string;
    isProcessed: boolean;
    processedAt: Date;
    data:
        | InventoryActionDataProcessCountingReportProduct
        | InventoryActionDataProcessPurchaseOrderProduct
        | InventoryActionDataInventoryMoveProduct
        | InventoryActionDataProcessInventoryMoveProduct;
    inventory: Inventory;
    inventoryId: number;
    user: User;
    userId: number;
};
export type InventoryCountingReportProduct = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    inventoryCountingReport: InventoryCountingReport;
    inventoryCountingReportId: number;
    product: Product;
    productId: number;
    unitAmountBefore: number;
    unitAmountAfter: number;
    unitAmountCorrection: number;
};
export type InventoryCountingReportSummary = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    data: any;
    inventory: Inventory;
    inventoryId: number;
    user: User;
    userId: number;
    inventoryCountingReports: InventoryCountingReport[];
};
export enum InventoryCountingReportType {
    SPILLAGE = 'SPILLAGE',
}
export type InventoryCountingReport = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type?: InventoryCountingReportType;
    date: Date;
    description: string;
    isConfirmed: boolean;
    data: any;
    inventory: Inventory;
    inventoryId: number;
    inventoryCountingReportSummary: InventoryCountingReportSummary;
    inventoryCountingReportSummaryId: number;
    user: User;
    userId: number;
    inventoryCountingReportProducts: InventoryCountingReportProduct[];
};
export type InventoryProduct = {
    inventory: Inventory;
    inventoryId: number;
    product: Product;
    productId: number;
    expectedUnitAmount: number;
    lastContainerPurchasePrice: number;
};
export type InventoryPurchaseOrderProduct = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    inventoryPurchaseOrder: InventoryPurchaseOrder;
    inventoryPurchaseOrderId: number;
    product: Product;
    productId: number;
    unitAmount: number;
    containerPrice: number;
};
export type InventoryPurchaseOrderVendor = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    inventoryPurchaseOrders: InventoryPurchaseOrder[];
    location: Location;
    locationId: number;
};
export type InventoryPurchaseOrder = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    description: string;
    date: Date;
    inventory: Inventory;
    inventoryId: number;
    inventoryPurchaseOrderVendor: InventoryPurchaseOrderVendor;
    inventoryPurchaseOrderVendorId: number;
    user: User;
    userId: number;
    inventoryPurchaseOrderProducts: InventoryPurchaseOrderProduct[];
};
export type Inventory = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    location: Location;
    locationId: number;
    inventoryProducts: InventoryProduct[];
    inventoryPurchaseOrders: InventoryPurchaseOrder[];
    inventoryActions: InventoryAction[];
    inventoryCountingReports: InventoryCountingReport[];
    inventoryCountingReportSummaries: InventoryCountingReportSummary[];
    outlets: Outlet[];
};
export enum InventoryOrderProductSyncType {
    SYNC = 'SYNC',
    REVERT = 'REVERT',
}
export type InventoryOrderProductSync = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    orderProduct: OrderProduct;
    orderProductId: number;
    isSynced: boolean;
    type: InventoryOrderProductSyncType;
};
export type IpData = {
    ip: string;
    latitude: number | 59.433;
    longitude: number | 24.7323;
    currencyCode: string | 'EUR';
    areaCode: string | '372';
    timeZone: string | 'Europe/Tallinn';
    city: string | 'Tallinn';
    region: string | 'Harjumaa';
    countryName: string | 'Estonia';
    countryCode: string | 'EE';
    continentCode: string | 'EU';
    isValid: boolean;
};
export type KdrSyncedOrder = {
    id: string;
    orderId: number;
    isSuccess: boolean;
    request?: any;
    response?: any;
    syncedAt: Date;
    errorCode?: number;
    errorMessage?: string;
    order: Order;
};
export type KioskDevice = {
    id: number;
    fingerprint: string;
    name: string;
    terminal: Terminal;
    terminalId: number;
    location: Location;
    locationId: number;
    outlet: Outlet;
    outletId: number;
    zone: Zone;
    zoneId: number;
};
export type LocationBalance = {
    location: Location;
    locationId: number;
    balance: Balance;
    balanceId: number;
};
export enum LocationConfigType {
    KDR_PRODUCT_SYNC = 'KDR_PRODUCT_SYNC',
    SERVICE_FEE_GROUPS = 'SERVICE_FEE_GROUPS',
    AUTO_SETTLE = 'AUTO_SETTLE',
    AUTO_PAYOUT = 'AUTO_PAYOUT',
    OUTLET_ZONE_GROUPS = 'OUTLET_ZONE_GROUPS',
    COUNT_BALANCE_PAYMENT_AS_REVENUE = 'COUNT_BALANCE_PAYMENT_AS_REVENUE',
    AUTO_PAY = 'AUTO_PAY',
    POS_MODULE_CONFIG = 'POS_MODULE_CONFIG',
    POS_COURSE_STYLES = 'POS_COURSE_STYLES',
    SETTLEMENT_VISMA_SYNC = 'SETTLEMENT_VISMA_SYNC',
    SETTLEMENT_E_JOURNAL_SYNC = 'SETTLEMENT_E_JOURNAL_SYNC',
    SETTLEMENT_ADYEN_PAYOUT = 'SETTLEMENT_ADYEN_PAYOUT',
    ORDER_AUTO_ARCHIVE = 'ORDER_AUTO_ARCHIVE',
    ZONE_IDLE_STATE = 'ZONE_IDLE_STATE',
    EXTERNAL_PAYMENT_METHOD_FEE = 'EXTERNAL_PAYMENT_METHOD_FEE',
    /**
     * @deprecated
     */
    OUTLET_GROUPS = 'OUTLET_GROUPS',
}
export type LocationConfigData =
    | LocationConfigDataKdrProductSync
    | LocationConfigDataServiceFeeGroups
    | LocationConfigDataAutoSettle
    | LocationConfigDataOutletZoneGroups
    | LocationConfigDataAutoPay
    | LocationConfigDataPosModuleConfig
    | LocationConfigDataPosCourseStyles
    | LocationConfigDataSettlementVismaSync
    | LocationConfigDataSettlementEJournalSync
    | LocationConfigDataSettlementAdyenPayout
    | LocationConfigDataOrderAutoArchive
    | LocationConfigDataZoneIdleState
    | LocationConfigDataExternalPaymentMethodFee;
export type LocationConfigDataKdrProductSync = {
    kdrProductIdsPreventSync: number[];
};
export type LocationConfigDataServiceFeeGroups = {
    defaultFee: number;
    groups: {
        id: number;
        from: number;
        to: number;
        feeAmount: number;
    }[];
};
export type LocationConfigDataAutoSettle = {
    hour: string;
};
export type LocationConfigDataOutletZoneGroups = {
    id: number;
    outletId: number;
    name: string;
    zoneIds: number[];
    zones: Zone[];
}[];
export type LocationConfigDataAutoPay = {
    terminalIdData: Record<
        number,
        {
            productId: number;
            isActive: boolean;
            outletId: number;
            price?: number;
        }
    >;
};
export type LocationConfigDataPosModuleConfig = {
    categoryStyle: Record<string, any>;
};
export type LocationConfigDataSettlementVismaSync = {};
export type LocationConfigDataSettlementEJournalSync = {};
export type LocationConfigDataSettlementAdyenPayout = {};
export type LocationConfigDataOrderAutoArchive = {
    archiveAfterMinutes?: number;
};
export type LocationConfigDataZoneIdleState = {
    redirect?: {
        afterXMinutes?: number;
        to?: 'SELECT_ZONE' | string;
        message?: string;
    };
};
export type LocationConfigDataExternalPaymentMethodFee = {
    methods?: {
        key: string;
        method: string;
        percent: number;
    }[];
};
export type LocationConfigDataPosCourseStyles = {
    rules: {
        id: number;
        courseId?: number[];
        requestStatus?: OrderProductRequestStatus[];
        minutes?: number;
        style?: any;
    }[];
};
export type LocationConfig = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: LocationConfigType;
    isActive: boolean;
    data: LocationConfigData;
    location: Location;
    locationId: number;
};
export type Location = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    hash: string;
    name: string;
    description: string;
    currency: string;
    timezoneMoment: string;
    browseTagId: string;
    imageLogo: string;
    imageBackground: string;
    latitude: number;
    longitude: number;
    city: string;
    isClosed: boolean;
    isHidden: boolean;
    isDevelopment: boolean;
    isEJournalActive: boolean;
    position: number;
    externalId: string;
    isVisibleInV1: boolean;
    isConfirmed: boolean;
    serviceFeeAmount: number;
    serviceFeePercent: number;
    isServiceFeeDisplayedInList: boolean;
    company: Company;
    companyId: number;
    adyenAccount: AdyenAccount;
    adyenAccountId: number;
    adyenStore: AdyenStore;
    adyenStoreId: number;
    adyenBalanceAccountId: string;
    orders: Order[];
    payments: Payment[];
    userLocationRoles: UserLocationRole[];
    outlets: Outlet[];
    settlements: Settlement[];
    locationSettlements: LocationSettlement[];
    integrations: Integration[];
    clients: Client[];
    pointOfSales: PointOfSale[];
    discounts: Discount[];
    inventories: Inventory[];
    miniInventories: MiniInventory[];
    products: Product[];
    accounts: Account[];
    recipes: Recipe[];
    menus: Menu[];
    variantGroups: VariantGroup[];
    inventoryPurchaseOrderVendors: InventoryPurchaseOrderVendor[];
    modifiers: Modifier[];
    modifierGroups: ModifierGroup[];
    paymentProviders: PaymentProvider[];
    tipGroups: TipGroup[];
    locationConfigs: LocationConfig[];
    adyenPayouts: AdyenPayout[];
    locationBalances: LocationBalance[];
    terminalPresets: TerminalPreset[];
    courses: Course[];
    features: Feature[];
    munuOrders: MunuOrder[];
    starPrinters: StarPrinter[];
    reports: Report[];
    posOperators: PosOperator[];
    posOperatorRoleGroups: PosOperatorRoleGroup[];
    spillageReports: SpillageReport[];
    paymentMethods: PaymentMethod[];
    terminals: Terminal[];
    zReports: ZReport[];
    productTags: ProductTag[];
    menuRules: MenuRule[];
    values: LocationValue[];
    i18ns: I18n[];
    systemModifications: SystemModification[];
    externalRequests: ExternalRequest[];
    kioskDevices: KioskDevice[];
    ingredients: Ingredient[];
};
export enum LocationSettlementStatus {
    PENDING = 'PENDING',
    FAILED = 'FAILED',
    CONFIRMED = 'CONFIRMED',
}
export type LocationSettlement = {
    id: number;
    sequence: number;
    status: LocationSettlementStatus;
    statusReason?: string;
    from: Date;
    to: Date;
    description?: string;
    timezone?: string;
    revenue?: number;
    location: Location;
    locationId: number;
    locationName: string;
    createdAt: Date;
    products: SettlementProduct[];
    payments: SettlementPayment[];
    events: SettlementEvent[];
};
export type LocationValueType = string | 'TABLE_CSS';
export type LocationValue = {
    location: Location;
    locationId: number;
    type: LocationValueType;
    value?: any;
    createdAt: Date;
    updatedAt: Date;
};
export type MenuProduct = {
    menu: Menu;
    menuId: number;
    product: Product;
    productId: number;
    price: number;
    priceTakeaway: number;
    position: number;
    isHidden: boolean;
};
export type MenuType = 'BREAKFAST' | 'LUNCH' | 'DINNER';
export type Menu = {
    id: number;
    externalId: string;
    name: string;
    type: MenuType;
    location: Location;
    locationId: number;
    createdAt: Date;
    updatedAt: Date;
    menuProducts: MenuProduct[];
    outlets: Outlet[];
    outletMenus: OutletMenu[];
    outletMenuChanges: OutletMenuChange[];
    zoneGroups: ZoneGroup[];
    rules: MenuRule[];
};
export type MenuRuleType = 'SHOW_PRODUCT' | 'HIDE_PRODUCT';
export type MenuRuleData = MenuRuleDataMatchValueFilter & { time?: Partial<MenuRuleDataTime> };
export type MenuRuleDataTime = Record<'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT' | 'SUN', MenuRuleDataTimePeriod[]>;
export type MenuRuleDataTimePeriod = { key: string; from?: string; to?: string; isActive: boolean };
export type MenuRuleDataMatchValueFilter = {
    type: 'SHOW_PRODUCT' | 'HIDE_PRODUCT';
    matchValue?: Record<keyof Product, any[]>;
};
export type MenuRule = {
    id: number;
    location: Location;
    locationId: number;
    menu: Menu;
    menuId: number;
    name: string;
    isActive: boolean;
    type: MenuRuleType;
    data: MenuRuleData;
    createdAt: Date;
    updatedAt: Date;
    times: MenuRuleTime[];
};
export type MenuRuleTimeDateRuleType = 'ENABLE' | 'DISABLE';
export type MenuRuleTime = {
    id: number;
    rule: MenuRule;
    ruleId: number;
    isActive: boolean;
    dateFrom: Date;
    dateTo: Date;
    dateRuleType: MenuRuleTimeDateRuleType;
    day: 1 | 2 | 3 | 4 | 5 | 6 | 7 | number;
    dayMinFrom: number;
    dayMinTo: number;
};
export type MiniInventoryProductCountByProductId = {
    [productId: number]: number;
};
export type MiniInventory = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    isActive: boolean;
    productCountByProductId?: MiniInventoryProductCountByProductId;
    location: Location;
    locationId: number;
};
export type ModifierGroupItem = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    modifierGroup: ModifierGroup;
    modifierGroupId: number;
    product: Product;
    productId: number;
    modifier: Modifier;
    modifierId: number;
    price: number;
    unitAmount: number;
    position: number;
    course: Course;
    courseId: number;
};
export enum ModifierGroupPresentationType {
    PACKAGE = 'PACKAGE',
    HORIZONTAL = 'HORIZONTAL',
}
export type ModifierGroupType = string;
export type ModifierGroup = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    nameInternal: string;
    nameStation: string;
    type: ModifierGroupType;
    presentationType: ModifierGroupPresentationType;
    name: string;
    description: string;
    autoSelectModifierId: number;
    autoSelectFirstModifier: boolean;
    createSeparateProducts: boolean;
    minAllowed: number;
    maxAllowed: number;
    location: Location;
    locationId: number;
    modifierGroupItems: ModifierGroupItem[];
    productModifierGroups: ProductModifierGroup[];
};
export type Modifier = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    externalId: string;
    nameInternal: string;
    name: string;
    description: string;
    position: number;
    location: Location;
    locationId: number;
    modifierGroupItems: ModifierGroupItem[];
};
export type MunuOrderRequest = { date: string; data: any; response: any; isError: boolean };
export type MunuOrder = {
    id: number;
    isSuccess: boolean;
    request?: MunuOrderRequest;
    munuOrderId?: number;
    order: Order;
    orderId: number;
    location: Location;
    locationId: number;
    createdAt: Date;
};
export type OrderProductModifier = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    guid: string;
    modifierGroupId: number;
    modifierGroupName: string;
    modifierGroupPresentationType: string;
    name: string;
    priceInitial: number;
    priceInitialExcludingVat: number;
    priceInitialVat: number;
    priceFinal: number;
    priceFinalExcludingVat: number;
    priceFinalVat: number;
    currency: string;
    productId: number;
    productName: string;
    productDescription: string;
    productIcon: string;
    productRootCategory: string;
    productCategory: string;
    productSubCategory: string;
    productUnitAmount: number;
    productContainer: string;
    productBaseUnit: string;
    productData: Partial<Product>;
    productAccountId: number;
    productAccountVatPercent: number;
    productAccountData: Partial<Account>;
    modifierId: number;
    modifierName: string;
    modifierData: any;
    discountId: number;
    discountName: string;
    discountVatPercent: number;
    discountData: any;
    orderProduct: OrderProduct;
    orderProductId: number;
};
export type OrderProductPayment = {
    orderProduct: OrderProduct;
    orderProductId: number;
    payment: Payment;
    paymentId: number;
};
export enum OrderProductStatus {
    PLACED = 'PLACED',
    IN_PREPARATION = 'IN_PREPARATION',
    READY = 'READY',
    IN_DELIVERY = 'IN_DELIVERY',
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED',
}
export enum OrderProductPaymentStatus {
    MISSING = 'MISSING',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED',
}
export enum OrderProductSaleType {
    REVENUE = 'REVENUE',
    INVOICE = 'INVOICE',
    TIP = 'TIP',
    SERVICE_FEE = 'SERVICE_FEE',
}
export enum OrderProductRequestStatus {
    HOLD = 'HOLD',
    REQUEST = 'REQUEST',
}
export type OrderProduct = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    guid: string;
    saleType: OrderProductSaleType;
    priceInitial: number;
    priceInitialExcludingVat: number;
    priceInitialVat: number;
    priceFinal: number;
    priceFinalExcludingVat: number;
    priceFinalVat: number;
    priceCombined: number;
    priceCombinedExcludingVat: number;
    priceCombinedVat: number;
    currency: string;
    status: OrderProductStatus;
    comment: string;
    productId: number;
    productName: string;
    productDescription: string;
    productIcon: string;
    productRootCategory: string;
    productCategory: string;
    productSubCategory: string;
    productData: Partial<Product>;
    productAccountId: number;
    productAccountVatPercent: number;
    productAccountData: Partial<Account>;
    discountId: number;
    discountName: string;
    discountPercent: number;
    discountData: Partial<Discount>;
    locationId: number;
    locationName: string;
    outletId: number;
    outletName: string;
    zoneId: number;
    zoneName: string;
    isTip: boolean;
    paymentStatus: OrderProductPaymentStatus;
    paymentStatusUpdatedAt: Date;
    requestStatus: OrderProductRequestStatus;
    dateMonth: string;
    dateDay: string;
    dateHour: string;
    dateMinute: string;
    order: Order;
    orderId: number;
    course: Course;
    courseId: number;
    orderProductPayments: OrderProductPayment[];
    orderProductModifiers: OrderProductModifier[];
    inventoryOrderProductSyncs: InventoryOrderProductSync[];
    splits: OrderProductSplit[];
    statusChanges: OrderProductStatusChange[];
    statusChangesTimestamps: OrderProductStatusChangeTimestamp[];
    locks: OrderProductLock[];
    ingredients: OrderProductIngredient[];
    stationOrderProducts: StationOrderProduct[];
    stationRequestOrderProducts: StationRequestOrderProduct[];
};
export enum OrderStatus {
    PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    ARCHIVED = 'ARCHIVED',
    /**
     * @deprecated
     */
    CANCELLED = 'CANCELLED',
    /**
     * @deprecated
     */
    REJECTED = 'REJECTED',
}
export enum OrderPlacedFrom {
    ZONE = 'ZONE',
    COUNTER = 'COUNTER',
}
export enum OrderPlacedBy {
    CUSTOMER = 'CUSTOMER',
    STAFF = 'STAFF',
}
export enum OrderDeliveryType {
    DELIVERY = 'DELIVERY',
    PICKUP = 'PICKUP',
}
export enum OrderVisibility {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
}
export type Order = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    guid: string;
    externalId: string;
    deviceFingerprint: string;
    deviceFingerprintLastInteraction: string;
    appVersion: string;
    comment: string;
    contactAreaCode: string;
    contactPhone: string;
    visibilityType: OrderVisibility;
    status: OrderStatus;
    isDisplayedToCustomer: boolean;
    placedBy: OrderPlacedBy;
    placedFrom: OrderPlacedFrom;
    placedAt: Date;
    archivedAt: Date;
    takeawayAt?: Date;
    deliveryType: OrderDeliveryType;
    sequence: number;
    hash: string;
    cronComment: string;
    settlement: Settlement;
    settlementId: number;
    user: User;
    userId: number;
    location: Location;
    locationId: number;
    outlet: Outlet;
    outletId: number;
    zone: Zone;
    zoneId: number;
    pointOfSale: PointOfSale;
    pointOfSaleId: string;
    eJournalCashTransaction: EJournalCashTransaction;
    eJournalCashTransactionId: string;
    orderProducts: OrderProduct[];
    kdrSyncedOrder: KdrSyncedOrder;
    kdrSyncedOrderId: string;
    munuOrder: MunuOrder;
    operatorOrders: PosOperatorOrder[];
};
export type OrderProductIngredient = {
    orderProduct: OrderProduct;
    orderProductId: number;
    ingredient: Ingredient;
    ingredientId: number;
    status: string | 'PLACED' | 'IN_PREPARATION' | 'READY';
    startedAt: Date;
    updatedAt: Date;
    finishedAt: Date;
    createdAt: Date;
};
export type OrderProductLock = {
    orderProduct: OrderProduct;
    orderProductId: number;
    deviceFingerprint: string;
    zoneId: number;
    lockedAt: Date;
};
export enum OrderProductSplitStatus {
    INITIATED = 'INITIATED',
    PAID = 'PAID',
    REFUNDED = 'REFUNDED',
}
export type OrderProductSplit = {
    payment: Payment;
    paymentId: number;
    orderProduct: OrderProduct;
    orderProductId: number;
    amount: number;
    status: OrderProductSplitStatus;
};
export type OrderProductStatusChange = {
    id: string;
    orderProduct: OrderProduct;
    orderProductId: number;
    name: string;
    rootCategory: string | 'FOOD' | 'DRINK' | 'OTHER';
    category: string;
    subCategory: string;
    status: string | 'PLACED' | 'IN_PREPARATION' | 'READY' | 'IN_DELIVERY' | 'DELIVERED' | 'CANCELLED';
    timestampPlaced: number;
    timestampChanged: number;
    timestamp: number;
    timestampDiff: number;
    datePlaced: Date;
    date: Date;
    posOperator: PosOperator;
    posOperatorId: number;
    posOperatorName: string;
    _raw?: any;
};
export type OrderProductStatusChangeTimestamp = {
    id: string;
    orderProduct: OrderProduct;
    orderProductId: number;
    date: Date;
    name: string;
    rootCategory: string | 'FOOD' | 'DRINK' | 'OTHER';
    category: string;
    subCategory: string;
    PLACED: number;
    IN_PREPARATION: number;
    READY: number;
    IN_DELIVERY: number;
    DELIVERED: number;
    CANCELLED: number;
};
export enum OutletConfigurationType {
    STATION_PRODUCT_STATUSES = 'STATION_PRODUCT_STATUSES',
    STATION_ORDER_CREATE_SETTLED_PAYMENT_WHEN_ARCHIVED = 'STATION_ORDER_CREATE_SETTLED_PAYMENT_WHEN_ARCHIVED',
    STATION_ORDER_CREATE_SETTLED_PAYMENT_WHEN_HANDED_OUT_BY_STAFF = 'STATION_ORDER_CREATE_SETTLED_PAYMENT_WHEN_HANDED_OUT_BY_STAFF',
    TERMINAL_PAYMENT_REQUIRED_FOR_DELIVERED = 'TERMINAL_PAYMENT_REQUIRED_FOR_DELIVERED',
    PRODUCT_CATEGORY_TO_STATUS_FLOW = 'PRODUCT_CATEGORY_TO_STATUS_FLOW',
}
export type OutletConfigurationTypeStationProductStatuses = OrderProductStatus[] | boolean;
export type OutletConfigurationTypeProductCategoryToStatusFlow = {
    [category: string]: string;
};
export type OutletConfigurationData =
    | OutletConfigurationTypeStationProductStatuses
    | OutletConfigurationTypeProductCategoryToStatusFlow
    | any;
export type OutletConfiguration = {
    type: OutletConfigurationType;
    isActive: boolean;
    data?: OutletConfigurationData;
    outlet: Outlet;
    outletId: number;
};
export enum OutletEventType {
    OPENING_TIMES = 'OPENING_TIMES',
    MENU_CHANGE = 'MENU_CHANGE',
}
export type OutletEvent = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    title: string;
    type: OutletEventType;
    isActive: boolean;
    data: any;
    outlet: Outlet;
    outletId: number;
};
export type OutletTerminalPreset = {
    outlet: Outlet;
    outletId: number;
    terminalPreset: TerminalPreset;
    terminalPresetId: number;
};
export enum OutletThemeColor {
    DARK = 'DARK',
    LIGHT = 'LIGHT',
    SYNG = 'SYNG',
}
export type Outlet = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    description: string;
    image: string;
    isClosed: boolean;
    isHidden: boolean;
    isDeleted: boolean;
    isCovidRegistrationRequired: boolean;
    isCovidRegistrationRequiredUpfront: boolean;
    covidRegistrationTagId: string;
    position: number;
    queueLimiterActive: boolean;
    queueLimiterActiveLimit: number;
    isCaptureWhenHandedOut: boolean;
    themeColor: OutletThemeColor;
    hash: string;
    externalId: string;
    location: Location;
    locationId: number;
    inventory: Inventory;
    inventoryId: number;
    menu: Menu;
    menuId: number;
    zones: Zone[];
    orders: Order[];
    outletConfigurations: OutletConfiguration[];
    outletOpenTimes: OutletOpenTime[];
    outletMenuChanges: OutletMenuChange[];
    outletEvents: OutletEvent[];
    covidRegistrations: CovidRegistration[];
    terminals: Terminal[];
    outletTerminalPresets: OutletTerminalPreset[];
    outletMenus: OutletMenu[];
    zoneGroups: ZoneGroup[];
    kioskDevices: KioskDevice[];
    stations: Station[];
    stationRequests: StationRequest[];
};
export enum OutletMenuType {
    POS = 'POS',
}
export type OutletMenu = {
    outlet: Outlet;
    outletId: number;
    menu: Menu;
    menuId: number;
    type: OutletMenuType;
};
export type OutletMenuChange = {
    id: number;
    day: number;
    minutesOffset: number;
    isActive: boolean;
    outlet: Outlet;
    outletId: number;
    menu: Menu;
    menuId: number;
    createdAt: Date;
};
export type OutletOpenTime = {
    id: number;
    day: number;
    minutesFrom: number;
    minutesTo: number;
    isActive: boolean;
    outlet: Outlet;
    outletId: number;
    createdAt: Date;
};
export enum PaymentEventType {
    API_REQUEST_PAYMENT_REQUEST = 'API_REQUEST_PAYMENT_REQUEST',
    API_REQUEST_CAPTURE = 'API_REQUEST_CAPTURE',
    API_REQUEST_REFUND = 'API_REQUEST_REFUND',
    REDIRECT_RETURN_RESULT = 'REDIRECT_RETURN_RESULT',
    AUTHORISATION = 'AUTHORISATION',
    CAPTURE = 'CAPTURE',
    TERMINAL_PAYMENT_SUCCESS = 'TERMINAL_PAYMENT_SUCCESS',
}
export type PaymentEvent = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type?: string | PaymentEventType;
    reference?: string;
    request?: any;
    response?: any;
    success?: boolean;
    timestamp?: Date;
    payment: Payment;
    paymentId: number;
};
export enum PaymentHistoryType {
    CREATE = 'CREATE',
    /**
     * @deprecated
     */
    CAPTURE = 'CAPTURE',
    /**
     * @deprecated
     */
    REFUND = 'REFUND',
    CANCEL_OR_REFUND = 'CANCEL_OR_REFUND',
    API_CALLBACK = 'API_CALLBACK',
}
export type PaymentHistory = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: PaymentHistoryType;
    amount: number;
    data: any;
    deviceFingerprint?: string;
    payment: Payment;
    paymentId: number;
    user: User;
    userId: number;
};
export enum PaymentTransactionType {
    SALE = 'SALE',
    REFUND = 'REFUND',
}
export type PaymentTransaction = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    payment: Payment;
    paymentId: number;
    type: PaymentTransactionType;
    amount: number;
    merchantGross: number;
    merchantCost: number;
    merchantNet: number;
    rdxGross: number;
    rdxCost: number;
    rdxNet: number;
};
export enum PaymentProvider {
    EXTERNAL = 'EXTERNAL',
    BAMBORA = 'BAMBORA',
    BAMBORA_VIPPS = 'BAMBORA_VIPPS',
    BAMBORA_MOBILE_PAY = 'BAMBORA_MOBILE_PAY',
    VIPPS = 'VIPPS',
    ADYEN = 'ADYEN',
    DEVELOPMENT = 'DEVELOPMENT',
    BALANCE_INVOICE = 'BALANCE_INVOICE',
    BALANCE_CREDIT = 'BALANCE_CREDIT',
}
export enum PaymentStatus {
    CREATED = 'CREATED',
    AUTHORISED = 'AUTHORISED',
    SETTLED = 'SETTLED',
    ERROR = 'ERROR',
    /**
     * @deprecated
     */
    CANCELLED_OR_REFUNDED = 'CANCELLED_OR_REFUNDED',
}
export enum PaymentMethodType {
    GIFT_CARD = 'GIFT_CARD',
    TERMINAL = 'terminal',
}
export type Payment = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    hash: string;
    guid: string;
    deviceFingerprint: string;
    appVersion: string;
    provider: PaymentProvider;
    providerOrderId: string;
    merchantReference: string;
    providerTransactionId: string;
    pspReference: string;
    methodType: string | PaymentMethodType | 'scheme' | 'vipps' | 'applepay' | 'paywithgoogle' | 'terminal';
    methodBrand: string | 'amex' | 'visa' | 'mastercard';
    referenceTxnFee: string;
    referenceServiceFee: string;
    referenceMerchant: string;
    txnAmountInitial: number;
    txnAmountTotal: number;
    txnCostPercent: number;
    txnCost: number;
    txnMerchantGross: number;
    txnMerchantNet: number;
    txnMerchantCost: number;
    txnRdxGross: number;
    txnRdxNet: number;
    txnRdxCost: number;
    txnAdyenFee: number;
    txnAdyenFeePercent: number;
    txnRefundAmount: number;
    txnRefundCost: number;
    status: PaymentStatus;
    currency: string;
    amount: number;
    amountInitial: number;
    amountRefund: number;
    settledAt: Date;
    cardNumber: string;
    cardMaskedPan: string;
    cardExpiryDate: string;
    comment: any;
    data: any;
    zone: Zone;
    zoneId: number;
    zoneName: string;
    outletId: number;
    outletName: string;
    adyenPayout: AdyenPayout;
    adyenPayoutId: number;
    location: Location;
    locationId: number;
    locationName: string;
    locationImageLogo: string;
    locationImageBackground: string;
    companyName: string;
    companyRegistrationNumber: string;
    companyAddressCountry: string;
    companyAddressRegion: string;
    companyAddressCity: string;
    companyAddressStreetName: string;
    companyAddressStreetNumber: string;
    companyAddressStreetPostalCode: string;
    isOrderArchived: boolean;
    eJournalCashTransaction: EJournalCashTransaction;
    eJournalCashTransactionId: string;
    terminalPayment: Terminal;
    terminal: Terminal;
    terminalId: number;
    user: User;
    userId: number;
    pointOfSale: PointOfSale;
    pointOfSaleId: string;
    settlement: Settlement;
    settlementId: number;
    balance: Balance;
    balanceId: number;
    clientInvoice: ClientInvoice;
    clientInvoiceId: number;
    paymentEvents: PaymentEvent[];
    orderProductPayments: OrderProductPayment[];
    terminalEvents: TerminalEvent[];
    paymentTransactions: PaymentTransaction[];
    paymentSplits: PaymentSplit[];
    operatorPayments: PosOperatorPayment[];
    orderProductSplits: OrderProductSplit[];
    fields: PaymentField[];
    queuedTerminals: Terminal[];
    txnAmountRefund: number;
    txnRdxFee: number;
    txnCostMerchant: number;
    txnCostRdx: number;
    providerMethod: string;
    providerPspReference: string;
    orderXFeeAmount: number;
    transactionFeeAmount: number;
    transactionFeePercent: number;
    payableAmount: number;
    txnFeePercent: number;
    txnFeeAmount: number;
    txnMerchantAmount: number;
    txnRdxAmount: number;
    paymentHistory: PaymentHistory[];
};
export type PaymentFieldType = 'fee_description' | 'representation_person' | 'representation_purpose' | 'is_invoice';
export type PaymentField = {
    id: number;
    payment: Payment;
    paymentId: number;
    type: PaymentFieldType;
    value: any;
};
export type PaymentMeta = {
    id: number;
    createdAt: Date;
    costPercent: number;
    paymentMethodType?: string | number | 'scheme';
    paymentMethodBrand?: string | 'mc';
    cardNumber?: string;
    raw?: any[];
    value?: any;
    error?: any;
};
export type PaymentMethod = {
    id: number;
    name: string;
    value: string;
    isActive: boolean;
    data?: any;
    description?: string;
    createdAt: Date;
    location: Location;
    locationId: number;
};
export enum PaymentSplitType {
    MarketPlace = 'MarketPlace',
    Commission = 'Commission',
    BalanceAccount = 'BalanceAccount',
}
export enum PaymentSplitAction {
    Capture = 'CAPTURE',
    Refund = 'REFUND',
}
export type PaymentSplit = {
    id: number;
    payment: Payment;
    paymentId: number;
    type: string | PaymentSplitType;
    action: string | 'CAPTURE' | 'REFUND';
    amount: number;
    account: string;
    reference: string;
    createdAt: Date;
};
export type PointOfSale = {
    id: string;
    description: string;
    location: Location;
    locationId: number;
    orders: Order[];
    payments: Payment[];
    createdAt: Date;
    updatedAt: Date;
};
export type PosDeviceEvent = {
    id: string;
    deviceFingerprint: string;
    label: string;
    date: Date;
    ref?: string;
    data?: number;
    createdAt: Date;
    updatedAt: Date;
};
export type PosOperator = {
    id: number;
    uuid: string;
    code: string;
    name?: string;
    description?: string;
    createdAt: Date;
    location: Location;
    locationId: number;
    roleGroup: PosOperatorRoleGroup;
    roleGroupId?: number;
    operatorOrders: PosOperatorOrder[];
    operatorPayments: PosOperatorPayment[];
    actions: PosOperatorAction[];
    spillageReports: SpillageReport[];
    orderProductStatusChanges: OrderProductStatusChange[];
};
export enum PosOperatorActionType {
    LOGIN = 'LOGIN',
    AUTHORISE = 'AUTHORISE',
    REFUND = 'REFUND',
}
export type PosOperatorAction = {
    id: number;
    operator: PosOperator;
    operatorId: number;
    type: PosOperatorActionType;
    value?: any;
    createdAt: Date;
};
export type PosOperatorOrder = {
    operator: PosOperator;
    operatorId: number;
    order: Order;
    orderId: number;
    createdAt: Date;
};
export type PosOperatorPayment = {
    operator: PosOperator;
    operatorId: number;
    payment: Payment;
    paymentId: number;
    createdAt: Date;
};
export enum PosOperatorRoleValue {
    CANCEL_AND_REFUND = 'CANCEL_AND_REFUND',
    DISCOUNT = 'DISCOUNT',
    POS_MODULE_SHORTCUT = 'POS_MODULE_SHORTCUT',
    POS_MODULE_LINK = 'POS_MODULE_LINK',
    POS_MODULE_CONTROL_CENTER = 'POS_MODULE_CONTROL_CENTER',
    POS_MODULE_CHANGE_NAV_LINKS = 'POS_MODULE_CHANGE_NAV_LINKS',
    POS_LAYOUT = 'POS_LAYOUT',
    POS_SPILLAGE = 'POS_SPILLAGE',
    STATION_SETTINGS = 'STATION_SETTINGS',
}
export type PosOperatorRole = {
    id: number;
    value: PosOperatorRoleValue;
    description?: string;
    roleGroupRoles: PosOperatorRoleGroupPosOperatorRole[];
};
export type PosOperatorRoleGroup = {
    id: number;
    ref?: string;
    name: string;
    sessionLengthMinutes?: number;
    createdAt: Date;
    location: Location;
    locationId: number;
    operators: PosOperator[];
    roleGroupRoles: PosOperatorRoleGroupPosOperatorRole[];
};
export type PosOperatorRoleGroupPosOperatorRole = {
    roleGroup: PosOperatorRoleGroup;
    roleGroupId: number;
    role: PosOperatorRole;
    roleId: number;
};
export type ProductModifierGroup = {
    product: Product;
    productId: number;
    modifierGroup: ModifierGroup;
    modifierGroupId: number;
    position: number;
};
export type ProductProductTag = {
    product: Product;
    productId: number;
    productTag: ProductTag;
    productTagId: number;
};
export type ProductTagType = 'HIDE_FROM_TAKEAWAY' | 'HIDE_FROM_TAKEAWAY_APP' | 'TABLE_PROMOTED';
export type ProductTag = {
    id: number;
    name: string;
    type: ProductTagType;
    location: Location;
    locationId: number;
    createdAt: Date;
    updatedAt: Date;
    productProductTags: ProductProductTag[];
};
export enum ProductCategoryRoot {
    FOOD = 'FOOD',
    DRINK = 'DRINK',
    OTHER = 'OTHER',
}
export enum ProductType {
    CONSUMABLE = 'CONSUMABLE',
    SERVICE = 'SERVICE',
    TIP = 'TIP',
    MODIFIER = 'MODIFIER',
    INVENTORY = 'INVENTORY',
    RECIPE = 'RECIPE',
    TICKET = 'TICKET',
    DYNAMIC_PRICE = 'DYNAMIC_PRICE',
}
export enum ProductContainer {
    OTHER = 'OTHER',
    BOTTLE = 'BOTTLE',
    TANK = 'TANK',
    KEG = 'KEG',
    PIECE = 'PIECE',
}
export enum ProductBaseUnit {
    OTHER = 'OTHER',
    OZ = 'OZ',
    L = 'L',
    DL = 'DL',
    CL = 'CL',
    ML = 'ML',
    /**
     * @deprecated
     */
    OUNCE = 'OUNCE',
    LITRE = 'LITRE',
    DECILITRE = 'DECILITRE',
    CENTILITRE = 'CENTILITRE',
    MILLILITRE = 'MILLILITRE',
}
export enum ProductUnitAmountType {
    OZ = 'OZ',
    L = 'L',
    DL = 'DL',
    CL = 'CL',
    ML = 'ML',
}
export enum ProductInventoryContainerType {
    OTHER = 'OTHER',
    BOTTLE = 'BOTTLE',
    TANK = 'TANK',
    KEG = 'KEG',
    PIECE = 'PIECE',
}
export enum ProductInventoryContainerUnitType {
    OZ = 'OZ',
    L = 'L',
    DL = 'DL',
    CL = 'CL',
    ML = 'ML',
}
export type Product = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    guid: string;
    externalId: string;
    name: string;
    nameInternal: string;
    description: string;
    rootCategory: ProductCategoryRoot;
    category: string;
    subCategory: string;
    price: number;
    priceTakeaway: number;
    icon: string;
    position: number;
    isOutOfStock: boolean;
    isHidden: boolean;
    isCommentAllowed: boolean;
    allergens: string[];
    type: ProductType;
    alcoholPercent: number;
    inventoryContainerType: ProductInventoryContainerType;
    inventoryContainerUnitType: ProductInventoryContainerUnitType;
    inventoryContainerUnitAmount: number;
    inventoryBaseUnitAmount: number;
    costPrice: number;
    location: Location;
    locationId: number;
    account: Account;
    accountId: number;
    purchaseAccount: Account;
    purchaseAccountId: number;
    takeawayAccount: Account;
    takeawayAccountId: number;
    variantGroup: VariantGroup;
    variantGroupId: number;
    defaultCourse: Course;
    defaultCourseId: number;
    defaultRequestStatus: OrderProductRequestStatus;
    variantGroupProducts: VariantGroupProduct[];
    inventoryProducts: InventoryProduct[];
    inventoryCountingReportProducts: InventoryCountingReportProduct[];
    recipeProducts: RecipeProduct[];
    menuProducts: MenuProduct[];
    recipes: Recipe[];
    modifierGroupItems: ModifierGroupItem[];
    tipGroups: TipGroup[];
    productModifierGroups: ProductModifierGroup[];
    discountProducts: DiscountProduct[];
    balanceProducts: BalanceProduct[];
    productProductTags: ProductProductTag[];
    productAccounts: ProductAccount[];
    productIngredients: ProductIngredient[];
    stationProducts: StationProduct[];
    container: ProductContainer;
    baseUnit: ProductBaseUnit;
    unitAmountType: ProductUnitAmountType;
    unitAmount: number;
    unitAmountBase: number;
};
export type ProductAccount = {
    product: Product;
    productId: number;
    account: Account;
    accountId: number;
};
export type ProductIngredient = {
    product: Product;
    productId: number;
    ingredient: Ingredient;
    ingredientId: number;
};
export enum QueueItemStatus {
    ACTIVE = 'ACTIVE',
    FINISHED = 'FINISHED',
    FAILED = 'FAILED',
}
export enum QueueItemType {
    VISMA_SYNC_SETTLEMENT = 'VISMA_SYNC_SETTLEMENT',
}
export type QueueItem = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    status?: QueueItemStatus;
    type: string | QueueItemType;
    uniqueId: string;
    data?: any;
    executionCount: number;
    executionCountLimit: number;
    executionNext?: Date;
    requests: any;
    errors: any;
};
export enum QueueTaskStatus {
    FAILED = 'FAILED',
    FINISHED = 'FINISHED',
}
export type QueueTask = {
    id: number;
    path: string;
    ref?: string;
    status?: QueueTaskStatus;
    data?: any;
    executionCount: number;
    executionCountLimit: number;
    executionNext?: Date;
    results: any[];
    createdAt: Date;
    updatedAt: Date;
};
export type RecipeProduct = {
    recipe: Recipe;
    recipeId: number;
    product: Product;
    productId: number;
    unitAmount: number;
    externalId: string;
};
export type Recipe = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    location: Location;
    locationId: number;
    product: Product;
    productId: number;
    externalId: string;
    recipeProducts: RecipeProduct[];
};
export enum ReportType {
    SETTLEMENT = 'SETTLEMENT',
}
export enum ReportStatus {
    GENERATING = 'GENERATING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}
export type Report = {
    id: number;
    ref: string;
    type: ReportType;
    description?: string;
    status: ReportStatus;
    data?: any;
    error?: string;
    location?: Location;
    locationId?: number;
    createdAt: Date;
};
export type RequestStatus = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    position: number;
    location: Location;
    locationId: number;
    products: Product[];
    orderProducts: OrderProduct[];
};
export type RuleType = 'EXCLUDE_ORDER_FROM_STATION';
export type Rule = {
    id: number;
    type: RuleType;
    values: RuleValue[];
};
export type RuleValue = {
    id: number;
    rule: Rule;
    ruleId: number;
    key: string;
    value: string;
};
export enum SentSmsType {
    USER_GENERATE_CONFIRMATION_CODE = 'USER_GENERATE_CONFIRMATION_CODE',
    ORDER_READY = 'ORDER_READY',
    RECEIPT_FROM_TERMINAL = 'RECEIPT_FROM_TERMINAL',
}
export type SentSms = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: SentSmsType;
    areaCode: string;
    phone: string;
    message: string;
    messageLength: number;
    keywords: string;
};
export type Settlement = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    settledAt: Date;
    sequence: number;
    periodStart: Date;
    periodEnd: Date;
    revenueTotalIncludingVat: number;
    isSyncedToEJournal: boolean;
    hasAdyenPayments: boolean;
    s3ObjectUrl: string;
    description?: string;
    orders: Order[];
    payments: Payment[];
    eJournalEventReports: EJournalEventReport[];
    settlementSyncRequests: SettlementSettlementSyncRequest[];
    location: Location;
    locationId: number;
    user: User;
    userId: number;
    adyenPayout: AdyenPayout;
    adyenPayoutId: number;
    vismaSettlement: VismaSettlement;
    tripletexSettlement: VismaSettlement;
    zReport: ZReport;
    vismaSettlementId: number;
};
export enum SettlementEventType {
    ADYEN_PAYOUT = 'ADYEN_PAYOUT',
    E_JOURNAL_SYNC = 'E_JOURNAL_SYNC',
    VISMA_SYNC = 'VISMA_SYNC',
}
export enum SettlementEventStatus {
    INITIATED = 'INITIATED',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}
export type SettlementEvent = {
    id: number;
    reference?: string;
    type: SettlementEventType;
    status: SettlementEventStatus;
    statusReason?: string;
    request?: any;
    response?: any;
    data?: any;
    settlement: LocationSettlement;
    settlementId: number;
    createdAt: Date;
    eventEJournalEventReports: SettlementEventEJournalEventReport[];
    eventEJournalCashTransactions: SettlementEventEJournalCashTransaction[];
};
export type SettlementEventEJournalCashTransaction = {
    event: SettlementEvent;
    eventId: number;
    eJournalCashTransaction: EJournalCashTransaction;
    eJournalCashTransactionId: string;
};
export type SettlementEventEJournalEventReport = {
    event: SettlementEvent;
    eventId: number;
    eJournalEventReport: EJournalEventReport;
    eJournalEventReportId: number;
};
export enum SettlementPaymentCountAs {
    REVENUE = 'REVENUE',
    INVOICE = 'INVOICE',
}
export type SettlementPayment = {
    id: number;
    settlement: LocationSettlement;
    settlementId: number;
    locationId: number;
    locationName: string;
    outletId: number;
    outletName: string;
    amountInitial: number;
    amount: number;
    amountRefund: number;
    merchantGross: number;
    merchantCost: number;
    merchantNet: number;
    costPercent: number;
    provider?: PaymentProvider;
    methodType: string | 'scheme' | 'vipps' | 'applepay' | 'paywithgoogle' | 'terminal';
    methodBrand: string | 'amex' | 'visa' | 'mastercard';
    countAs?: SettlementPaymentCountAs;
    createdAt: Date;
    productPayments: SettlementProductPayment[];
};
export enum SettlementProductStatus {
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED',
}
export enum SettlementProductSaleType {
    SALE = 'SALE',
    TIP = 'TIP',
    SERVICE_FEE = 'SERVICE_FEE',
}
export enum SettlementProductCountAs {
    REVENUE = 'REVENUE',
    INVOICE = 'INVOICE',
}
export type SettlementProduct = {
    id: number;
    key: string;
    settlement: LocationSettlement;
    settlementId: number;
    locationId: number;
    locationName: string;
    outletId: number;
    outletName: string;
    orderId: number;
    orderProductOrModifierId: number;
    productId?: number;
    name?: string;
    status?: SettlementProductStatus;
    saleType?: SettlementProductSaleType;
    countAs?: SettlementProductCountAs;
    amount: number;
    amountVat: number;
    amountExclVat: number;
    type: 'PRODUCT' | 'MODIFIER';
    accountId?: number;
    accountType?: string;
    accountName?: string;
    accountCode?: string;
    accountVatPercent?: number;
    placedAt: Date;
    createdAt: Date;
    productPayments: SettlementProductPayment[];
};
export type SettlementProductPayment = {
    product: SettlementProduct;
    productId: number;
    payment: SettlementPayment;
    paymentId: number;
};
export type SettlementSettlementSyncRequest = {
    settlement: Settlement;
    settlementId: number;
    syncRequest: SettlementSyncRequest;
    syncRequestId: number;
};
export type SettlementSyncRequestProvider = 'TRIPLETEX' | 'SEVEN_OFFICE_24';
export type SettlementSyncRequestStatus = 'PENDING' | 'SUCCESS' | 'ERROR' | 'MANUALLY_HANDLED';
export type SettlementSyncRequest = {
    id: number;
    provider: SettlementSyncRequestProvider;
    status: SettlementSyncRequestStatus;
    requestUrl: string;
    requestData: any;
    response?: any;
    createdAt: Date;
    settlementSyncRequests: SettlementSettlementSyncRequest[];
};
export type SpillageReport = {
    id: number;
    date: Date;
    reason: string;
    location: Location;
    locationId: number;
    posOperator: PosOperator;
    posOperatorId?: number;
    items: SpillageReportItem[];
    createdAt: Date;
};
export type SpillageReportItem = {
    id: number;
    unitAmount: number;
    costPrice?: number;
    productId: number;
    productName: string;
    creditAccountCode?: string;
    creditAccountName?: string;
    creditAccountData?: Account;
    debitAccountCode?: string;
    debitAccountName?: string;
    debitAccountData?: Account;
    report: SpillageReport;
    reportId: number;
};
export type StarPrinter = {
    id: number;
    name: string;
    topic: string;
    host: string;
    port: string;
    username: string;
    password: string;
    createdAt: Date;
    location?: Location;
    locationId?: number;
};
export type Station = {
    id: number;
    name: string;
    outlet: Outlet;
    outletId: number;
    createdAt: Date;
    stationProducts: StationProduct[];
    stationIngredients: StationIngredient[];
    stationOrderProducts: StationOrderProduct[];
};
export type StationIngredient = {
    station: Station;
    stationId: number;
    ingredient: Ingredient;
    ingredientId: number;
    createdAt: Date;
};
export type StationOrderProduct = {
    station: Station;
    stationId: number;
    orderProduct: OrderProduct;
    orderProductId: number;
    createdAt: Date;
};
export type StationProduct = {
    station: Station;
    stationId: number;
    product: Product;
    productId: number;
};
type Status = 'active' | 'inactive' | string;
export type StationRequest = {
    id: number;
    status: Status;
    requestedAt: Date;
    requestedFinishAt: Date;
    orderProducts: StationRequestOrderProduct[];
    outlet: Outlet;
    outletId: number;
};
export type StationRequestOrderProduct = {
    request: StationRequest;
    requestId: number;
    orderProduct: OrderProduct;
    orderProductId: number;
};
export type SystemModificationStatus = 'NEW' | 'ARCHIVED';
export type SystemModificationType =
    | SystemModificationTypePaymentRefund
    | SystemModificationTypePaymentAmountsCorrection;
export type SystemModificationTypePaymentRefund = 'PAYMENT_REFUND';
export type SystemModificationTypePaymentAmountsCorrection = 'PAYMENT_AMOUNTS_CORRECTION';
export type SystemModificationValue =
    | SystemModificationValuePaymentRefund
    | SystemModificationValuePaymentAmountsCorrection;
export type SystemModificationValuePaymentRefund = {
    type: SystemModificationTypePaymentRefund;
    paymentId: number;
    amount: number;
    orderProducts: {
        id: number;
        name: string;
        amount: number;
    }[];
    settlementId?: number;
    settlementSequence?: number;
};
export type SystemModificationValuePaymentAmountsCorrection = {
    type: SystemModificationTypePaymentAmountsCorrection;
    id: number;
    settlementId?: number;
    settlementSequence?: number;
    before: Partial<Payment>;
    after: Partial<Payment>;
};
export type SystemModification = {
    id: number;
    ref: string;
    reason: string;
    status: SystemModificationStatus;
    type: SystemModificationType;
    value: SystemModificationValue;
    location: Location;
    locationId: number;
    createdAt: Date;
};
export enum SystemNotificationType {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
}
export enum SystemNotificationEvent {
    MUNU_ORDER_SYNC_ERROR = 'MUNU_ORDER_SYNC_ERROR',
    VISMA_SETTLEMENT_SYNC_ERROR = 'VISMA_SETTLEMENT_SYNC_ERROR',
    QUEUE_DEAD_TASK = 'QUEUE_DEAD_TASK',
    SETTLEMENT_AUTO_SETTLE_FAIL = 'SETTLEMENT_AUTO_SETTLE_FAIL',
    SETTLEMENT_AUTO_PAY_OUT_FAIL = 'SETTLEMENT_AUTO_PAY_OUT_FAIL',
    ERROR = 'ERROR',
}
export type SystemNotificationData =
    | SystemNotificationDataMunuOrderSyncErrorData
    | SystemNotificationDataQueueDeadTask
    | SystemNotificationDataSettlementAutoSettleFail
    | SystemNotificationDataError
    | any;
export type SystemNotificationDataMunuOrderSyncErrorData = {
    locationId: number;
    orderId: number;
    munuOrderId?: number;
    request?: any;
    response?: any;
};
export type SystemNotificationDataQueueDeadTask = {
    taskId: number;
    message?: string;
    payload?: any;
};
export type SystemNotificationDataSettlementAutoSettleFail = {
    locationId?: number;
    openOrderCount?: number;
    openOrderIds?: number[];
};
export type SystemNotificationDataError = any & {
    message: string;
};
export type SystemNotification = {
    id: number;
    type: SystemNotificationType;
    event: SystemNotificationEvent;
    message: string;
    data?: SystemNotificationData;
    isHandled: boolean;
    createdAt: Date;
};
export enum TagType {
    ZONE = 'ZONE',
    OUTLET = 'OUTLET',
    OUTLET_GROUP_TO_ZONE = 'OUTLET_GROUP_TO_ZONE',
    OUTLET_GROUP = 'OUTLET_GROUP',
    DISCOUNT_CLAIM = 'DISCOUNT_CLAIM',
    OUTLETS_PRODUCTS_SHOW = 'OUTLETS_PRODUCTS_SHOW',
    COVID_REGISTRATION = 'COVID_REGISTRATION',
}
export type TAG_DATA_ZONE = {
    zoneId: number;
};
export type TAG_DATA_OUTLET = {
    outletId: number;
};
export type TAG_DATA_OUTLET_GROUP_TO_ZONE = {
    title: string;
    outletIds: number[];
    zoneNumber: number;
};
export type TAG_DATA_OUTLET_GROUP = {
    title: string;
    outletIds: number[];
};
export type TAG_DATA_DISCOUNT_CLAIM = {
    discountId: number;
    outletId?: number;
    zoneId?: number;
    persist?: boolean;
};
export type TAG_DATA_OUTLETS_PRODUCTS_SHOW = {
    locationId: number;
    outletIds: number[];
    productIds: number[];
};
export type TAG_DATA_COVID_REGISTRATION = {
    locationId: number;
    outletId?: number;
    outletIds?: number[];
    isZoneRequired?: boolean;
};
export type TAG_DATA =
    | TAG_DATA_ZONE
    | TAG_DATA_OUTLET
    | TAG_DATA_OUTLET_GROUP_TO_ZONE
    | TAG_DATA_DISCOUNT_CLAIM
    | TAG_DATA_OUTLETS_PRODUCTS_SHOW
    | TAG_DATA_COVID_REGISTRATION;
export type Tag = {
    id: string;
    type: TagType;
    value: string;
    data: TAG_DATA;
    name: string;
    position: number;
    description: string;
    createdAt: Date;
    updatedAt: Date;
};
export enum TaskStatus {
    EXECUTING = 'EXECUTING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    DEAD = 'DEAD',
}
export enum TaskType {
    ADYEN_PAY_OUT = 'ADYEN_PAY_OUT',
    ADYEN_SETTLEMENT_DETAILS_SYNC = 'ADYEN_SETTLEMENT_DETAILS_SYNC',
    MUNU_ORDER_SYNC = 'MUNU_ORDER_SYNC',
    SETTLEMENT_EVENT = 'SETTLEMENT_EVENT',
    VISMA_SETTLEMENT_SYNC = 'VISMA_SETTLEMENT_SYNC',
}
export type Task = {
    id: number;
    reference: string;
    executeAt: Date;
    executedAt?: Date;
    iteration: number;
    maxIterationCount: number;
    type: string | TaskType;
    payload?: any;
    status?: TaskStatus;
    response?: any;
    deleteAt?: Date;
    createdAt: Date;
};
type Type = string | 'requested_by_waiter';
export type Temp = {
    id: string;
    type: Type;
    valueN: number;
    valueS: string;
    valueD: Date;
    createdAt: Date;
};
export enum TerminalEventType {
    IDLE = 'IDLE',
    PAYMENT_REQUEST = 'PAYMENT_REQUEST',
    PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
    PAYMENT_ERROR = 'PAYMENT_ERROR',
}
export type TerminalEvent = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: TerminalEventType;
    errorCondition: string;
    timestamp: Date;
    request: any;
    response: any;
    terminal: Terminal;
    terminalId: number;
    payment: Payment;
    paymentId: number;
    lastTerminalEvent: Terminal;
};
export type TerminalPresetTerminal = {
    terminalPreset: TerminalPreset;
    terminalPresetId: number;
    terminal: Terminal;
    terminalId: number;
    position: number;
};
export type TerminalPreset = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    location: Location;
    locationId?: number;
    name?: string;
    isActive?: boolean;
    terminalPresetTerminals: TerminalPresetTerminal[];
    outletTerminalPresets: OutletTerminalPreset[];
};
export enum TerminalLastEvent {
    BEGIN_MAINTENANCE = 'BeginMaintenance',
    END_MAINTENANCE = 'EndMaintenance',
    SHUTDOWN = 'Shutdown',
    INITIALISED = 'Initialised',
    OUT_OF_ORDER = 'OutOfOrder',
    COMPLETED = 'Completed',
    ABORT = 'Abort',
    SAKE_WAKE_UP = 'SaleWakeUp',
    SALE_ADMIN = 'SaleAdmin',
    CUSTOMER_LANGUAGE = 'CustomerLanguage',
    KEY_PRESSED = 'KeyPressed',
    SECURITY_ALARM = 'SecurityAlarm',
    STOP_ASSISTANCE = 'StopAssistance',
    CARD_INSERTED = 'CardInserted',
    CARD_REMOVED = 'CardRemoved',
    REJECT = 'Reject',
}
export type Terminal = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    pOIID: string;
    name: string;
    referenceId: string;
    isActive: boolean;
    model: string;
    serialNumber: string;
    permanentTerminalId: string;
    adyenAppVersion: string;
    merchant: string;
    lastEvent: string | AdyenNotificationTerminalEventToNotify | TerminalLastEvent;
    lastEventTimestamp: string;
    pendingServiceId?: string;
    pendingServiceCreatedAt?: Date;
    company: Company;
    companyId: number;
    location: Location;
    locationId?: number;
    outlet: Outlet;
    outletId: number;
    nextTerminalService?: TerminalService;
    nextTerminalServiceId?: number;
    queuedPayment?: Payment;
    queuedPaymentId?: number;
    adyenNotificationTerminals: AdyenNotificationTerminal[];
    payments: Payment[];
    terminalPresetTerminals: TerminalPresetTerminal[];
    kioskDevices: KioskDevice[];
    lastTerminalEvent: TerminalEvent;
    lastTerminalEventId: number;
    terminalPayment: Payment;
    terminalPaymentId: number;
};
export enum TerminalServiceType {
    PAYMENT = 'PAYMENT',
    PRINT = 'PRINT',
}
export type TerminalServiceData = TerminalServiceDataPayment | TerminalServiceDataPrint;
export type TerminalServiceDataPayment = {
    type: TerminalServiceType.PAYMENT;
    paymentId: number;
};
export type TerminalServiceDataPrint = {
    type: TerminalServiceType.PRINT;
    paymentId: number;
};
export type TerminalService = {
    id: number;
    data: TerminalServiceData;
    createdAt: Date;
    nextTerminalServiceTerminals: Terminal[];
};
export type TipGroup = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    isActive: boolean;
    presetPercent: number[];
    location: Location;
    locationId: number;
    product: Product;
    productId: number;
};
export type TripletexSettlement = {
    id: number;
    request: any;
    response?: any;
    error?: any;
    settlement: Settlement;
    settlementId: number;
    zReport: ZReport;
    zReportId: number;
    createdAt: Date;
};
export type UserBalance = {
    user: User;
    userId: number;
    balance: Balance;
    balanceId: number;
};
export type UserCompanyRole = {
    user: User;
    userId: number;
    company: Company;
    companyId: number;
};
export enum UserLocationRoleValue {
    ADMIN = 'ADMIN',
    STAFF = 'STAFF',
}
export type UserLocationRole = {
    user: User;
    userId: number;
    location: Location;
    locationId: number;
    value: UserLocationRoleValue;
};
export type User = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    username: string;
    password: string;
    awsCognitoUsernameApp: string;
    awsCognitoUsernameAdmin: string;
    firstName: string;
    lastName: string;
    email: string;
    areaCode: string;
    phone: string;
    isClaimed: boolean;
    isConfirmed: boolean;
    confirmationCode: string;
    confirmationCodeSent: Date;
    stripeCustomerId: string;
    isSuperAdmin: boolean;
    authAttempts: number;
    authAttemptsTotal: number;
    lastAuthAttemptAt: Date;
    payments: Payment[];
    userCompanyRoles: UserCompanyRole[];
    userLocationRoles: UserLocationRole[];
    userBalances: UserBalance[];
    orders: Order[];
    inventoryActions: InventoryAction[];
    inventoryPurchaseOrders: InventoryPurchaseOrder[];
    inventoryCountingReports: InventoryCountingReport[];
    inventoryCountingReportSummaries: InventoryCountingReportSummary[];
    paymentHistory: PaymentHistory[];
    settlements: Settlement[];
    covidRegistrations: CovidRegistration[];
    discountUsers: DiscountUser[];
};
export type ValueId =
    | `LOC_${number}_TX_PERCENT`
    | `LOC_${number}_ORDER_PRODUCT_STATUS_FOR_SMS`
    | `LOC_${number}_SETTLEMENT_SYNC_NEW`
    | `LOC_${number}_POS_COURSE_MANAGEMENT`
    | `OUTLET_${number}_POS_COURSE_MANAGEMENT`
    | 'ADYEN_LAST_SETTLEMENT_SYNC_ECOM'
    | 'ADYEN_LAST_SETTLEMENT_SYNC_POS'
    | `DEVICE_${string}_SETTLED`
    | string;
export type Value = {
    id: ValueId;
    value: any;
    description: string;
    createdAt: Date;
    updatedAt: Date;
};
export type VariantGroupProduct = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    variantGroup: VariantGroup;
    variantGroupId: number;
    product: Product;
    productId: number;
    price: number;
    position: number;
};
export type VariantGroup = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    nameInternal: string;
    name: string;
    description: string;
    location: Location;
    locationId: number;
    products: Product[];
    variantGroupProducts: VariantGroupProduct[];
};
export type VismaSettlement = {
    id: number;
    settlement: Settlement;
    settlementId: number;
    requestUrl?: string;
    requestData?: any;
    response?: any;
    createdAt: Date;
    updatedAt: Date;
};
export enum ZoneOrderVisibilityType {
    PUBLIC = 'PUBLIC',
    USER_ORDERS_ONLY = 'USER_ORDERS_ONLY',
}
export enum ZonePaymentType {
    UPFRONT = 'UPFRONT',
    AFTER = 'AFTER',
}
export enum ZoneLayoutType {
    DEFAULT = 'DEFAULT',
    COMPACT = 'COMPACT',
    GROUPED_BY_CATEGORY = 'GROUPED_BY_CATEGORY',
}
export enum ZoneOrderDeliveryType {
    DELIVERY = 'DELIVERY',
    PICKUP = 'PICKUP',
    TAKEAWAY = 'TAKEAWAY',
    SHOW_CODE = 'SHOW_CODE',
}
export type Zone = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    hash: string;
    name: string;
    isClosed: boolean;
    isHidden: boolean;
    hasTakeaway: boolean;
    position: number;
    externalId: string;
    orderVisibilityType: ZoneOrderVisibilityType;
    paymentType: ZonePaymentType;
    layoutType: ZoneLayoutType;
    orderDeliveryType: ZoneOrderDeliveryType;
    isPayMode: boolean;
    outlet: Outlet;
    outletId: number;
    orders: Order[];
    payments: Payment[];
    zoneGroupZones: ZoneGroupZone[];
    values: ZoneValue[];
    kioskDevices: KioskDevice[];
};
export type ZoneGroup = {
    id: number;
    outlet: Outlet;
    outletId: number;
    name: string;
    menu: Menu;
    menuId: number;
    createdAt: Date;
    updatedAt: Date;
    parents: ZoneGroupZoneGroup[];
    children: ZoneGroupZoneGroup[];
    zoneGroupZones: ZoneGroupZone[];
};
export type ZoneGroupZone = {
    zoneGroup: ZoneGroup;
    zoneGroupId: number;
    zone: Zone;
    zoneId: number;
};
export type ZoneGroupZoneGroup = {
    parent: ZoneGroup;
    parentId: number;
    child: ZoneGroup;
    childId: number;
};
export type ZoneValueType = 'CALLING_WAITER' | 'NUM_PEOPLE' | 'SHOW_ALLERGENS';
export type ZoneValue = {
    zone: Zone;
    zoneId: number;
    type: ZoneValueType;
    value?: any;
    createdAt: Date;
    updatedAt: Date;
};
export type ZReportStatus = 'OPEN' | 'PENDING_CONFIRMATION' | 'CONFIRMED';
export type ZReport = {
    id: number;
    ref: string;
    location: Location;
    locationId: number;
    sequence: number;
    dateTimezone: string;
    date: string | '2022-12-08';
    dateFrom: Date;
    dateTo: Date;
    dateStartHour: number;
    amountSales: number;
    amountRevenue: number;
    amountNonRevenue: number;
    status: ZReportStatus;
    items: ZReportItem[];
    payments: ZReportPayment[];
    tripletexSettlement: TripletexSettlement;
    adyenPayout: AdyenPayout;
    adyenPayoutId: number;
    settlement: Settlement;
    settlementId: number;
    createdAt: Date;
};
export type ZReportItemType = 'PRODUCT' | 'MODIFIER' | 'TIP' | 'FEE';
export type ZReportItem = {
    id: string;
    report: ZReport;
    reportId: number;
    order: ZReportOrder;
    orderId: number;
    groupId: string;
    type: ZReportItemType;
    name: string;
    price: number;
    priceExcludingVat: number;
    vatAmount: number;
    vatPercent: number;
    accountDisplayName?: string;
    accountName?: string;
    accountCode?: string;
    outletId?: number;
    outletName?: string;
    zoneId?: number;
    zoneName?: string;
    createdAt: Date;
    _accountId?: number;
    _orderProductId?: number;
    _orderProductModifierId?: number;
    _raw?: any;
    itemPayments: ZReportItemPayment[];
};
export type ZReportItemPayment = {
    item: ZReportItem;
    itemId: string;
    payment: ZReportPayment;
    paymentId: number;
    fraction: number;
    amount: number;
    amountVat: number;
    amountExclVat: number;
};
export type ZReportOrder = {
    id: number;
    report: ZReport;
    reportId: number;
    createdAt: Date;
    items: ZReportItem[];
    _raw?: any;
};
export type ZReportPaymentSaleType = 'REVENUE' | 'NON_REVENUE';
export type ZReportPayment = {
    id: number;
    report: ZReport;
    reportId: number;
    ref?: string;
    saleType: ZReportPaymentSaleType;
    provider: 'ADYEN' | 'BAMBORA' | 'ETC...' | string;
    method: 'TERMINAL' | 'GIFT_CARD' | 'CASH' | 'ETC...' | string;
    amount: number;
    amountRefund: number;
    txCostPercent: number;
    txCostPercentDescription: string;
    feeGross: number;
    feeCost: number;
    feeNet: number;
    merchantGross: number;
    merchantCost: number;
    merchantNet: number;
    outletId?: number;
    outletName?: string;
    zoneId?: number;
    zoneName?: string;
    createdAt: Date;
    itemPayments: ZReportItemPayment[];
    _raw?: any;
};

export namespace SharedType {
    export type Nullable<T> = { [K in keyof T]: T[K] | null };

    export type DataQueryInput<T> = T & {
        pagination: { limit: number; offset: number };
    };

    export type DataQueryOutput<T> = {
        count: number;
        items: (T & { key: string | number })[];
    };

    export type SocketEvent = SocketEventZoneOrderCreate | SocketEventZoneOrderUpdate;

    export type SocketEventZoneOrderCreate = {
        event: `zone/:zoneId/order/create`;
        data: any;
    };

    export type SocketEventZoneOrderUpdate = {
        event: `zone/:zoneId/order/update`;
        data: any;
    };

    export namespace Service {
        export namespace analytics {
            export namespace query {
                export namespace analyticsQueryPosOverview {
                    export type Input = {
                        locationId: number;
                        from: string;
                        to: string;
                        groupBy?: 'outlet';
                    };

                    export type Output = Summary & {
                        outlets: Summary[];
                    };

                    export type Summary = {
                        key: number;
                        name: string;
                        amount: number;
                        count: number;
                        avgPayment: number;
                        drinkPercentageOfTotal: number;
                        perPeriod?: {
                            label: string;
                            items: {
                                key: string;
                                label: string;
                                amount: number;
                                percent: number;
                            }[];
                        };
                        products: {
                            id: number;
                            name: string;
                            count: number;
                            amount: number;
                        }[];
                    };
                }
            }
        }
    }

    export namespace Model {
        export namespace Settlement {
            export namespace createReport {
                export type Input = {
                    locationId: number;
                    from: string;
                    to: string;
                    includeOrderType: 'SETTLEMENT' | 'PERIOD';
                    groupByPeriod?: 'DAY' | 'MONTH';
                    outletIds?: number[];
                };

                export type Output = {
                    location: { name: string };
                    isCountBalanceAsRevenue: boolean;
                    dataSettlements?: DataObject & {
                        settlements: {
                            id: number;
                            sequence: number;
                            from?: Date;
                            to: Date;
                        }[];
                    };
                    dataByDay?: (DataObject & { date: string })[];
                    dataByPeriod?: DataObject;
                };

                export type DataObject = {
                    tip: (Shared & {
                        key: string;
                        saleType: string;
                    })[];
                    vat: (Shared & {
                        key: string;
                        vatPercent: number;
                        saleType: string;
                    })[];
                    product: (Shared & {
                        id: number;
                        name: string;
                        pricePerUnit: number;
                    })[];
                    account: (Shared & {
                        id: number;
                        code: string;
                        name: string;
                        vatPercent: number;
                    })[];
                    payment: (Shared & {
                        provider: string;
                        name: string;
                        refunds: 0;
                    })[];
                    fee: (Shared & {
                        percent: number;
                    })[];
                };

                export type Shared = SaleAmount & {
                    key: string;
                    saleType: string;
                    revenueType: 'REVENUE' | 'NON_REVENUE';
                };

                export type SaleAmount = {
                    count: number;
                    net: number;
                    vat: number;
                    gross: number;
                };
            }
        }
    }
}
